import React, { useEffect } from "react";
import { CaretUpFilled, CaretDownFilled } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { Tooltip } from "antd";
import {
  setIsDeepDiveDashboard,
  setSelectedDeepdiveWidget,
  setisDeepDive,
} from "../../redux/actions/dashboard/Tab1";
import {
  deepCopy,
  getAllFilters,
  getAllShareFilters,
  getBrands,
  getCustomizedDate,
  getGlobalBrands,
  getPaneIndex,
  kFormatter,
  useQuery,
  callNotification,
  getAllDeepDiveDashboardFilters,
  getWindowLocationPath,
} from "../../redux/constants";
import moment from "moment";
import {
  setDeepDiveInfoLoader,
  setIsDetailedInsightVisible,
  setTabClick,
  setMentionPageData,
} from "../../redux/actions/DeepDive";
import {
  setDeepDiveInfluencersObject,
  setDeepDiveMentionsObject,
  setDeepDiveObject,
  set_WM_DeepDive,
} from "../../redux/actions/WidgetMaker/WidgetMaker";
import { getDeepDive } from "../../redux/actions/WidgetMaker/WidgetAPI";
import defaultImage from "../../assets/brandLogos/Default_Brand.svg";
import isEqual from "react-fast-compare";
import { SocialMedialogo } from "../layout/DeepDive/DeepDivetab/SocialMediaPlatforms";
import { isString } from "highcharts";
import { setShareSelectedDeepdiveWidget } from "../../redux/actions/share/Share";
import { useMemo } from "react";
import { SecondstoHumanReadable } from "../utils/charts/HighCharts/graphFunction";
import { getCountryLogo, getGenderLogo } from "../utils/Logos";
import { setupdatedGraphData } from "../../redux/actions/widget/widget";
import { setOptionHighChart } from "../../redux/actions/HighChart";
import { supportedBenchmarkTraceChartTypes } from "../../redux/constants/enums";
import {
  setInitialDeepDiveDashboardData,
  setIsDeepDiveInDashboardTemplateData,
} from "../../redux/actions/DeepDiveDashboard/DeepDiveDashboard";
import RoiKpi from "./RoiKpi/RoiKpi";

const KpiCards = ({
  metaWidgetKpiData,
  widgetGraphConfig,
  count,
  cardPosition,
  widgetShareOfData,
  widgetDurationComparison,
  type,
  dashboard,
  PdfDownloadStatus,
  ppt_generating_status,
  widget_index,
  section_index,
  kpi_data,
  noteExist,
  metaWidgetConfig,
  isPreviewState,
}) => {
  const dispatch = useDispatch();
  let pathName = window.location.pathname?.split("/")?.[1];
  let query = useQuery();
  const personalizationSettingsObj = useSelector(
    (state) => state?.PersonalizationSetting
  );
  const panes = useSelector((state) => state?.Tab1?.panes);
  const activeKey = useSelector((state) => state?.Tab1?.activeKey);
  const Section = useSelector((state) => state.Section.addSection);
  const global_dashboard_duration = useSelector(
    (state) => state.AuthParams.global_dashboard_duration
  );
  const allAttributes = useSelector(
    (state) => state?.attributes?.allAttributes
  );
  const shareTemplateData = useSelector(
    (state) => state.ApiCall.shareTemplateData
  );
  const shareableLinkDeepDiveStatus = useSelector(
    (state) => state.ApiCall.shareableLinkDeepDiveStatus
  );
  const sharedDuration = useSelector((state) => state.Share.sharedDuration);
  const shareCategory = useSelector((state) => state.ApiCall.shareCategory);
  const authParams = useSelector((state) => state.Authentication.authParams);
  const shareBrands = useSelector((state) => state.ApiCall.shareBrands);
  const deepdive_object = useSelector(
    (state) => state?.WidgetMaker?.deepdive_object
  );
  const brandlogicalgroup = useSelector(
    (state) => state.ApiCall.brandlogicalgroup?.data?.result
  );
  const global_dashboard_brands = useSelector(
    (state) => state.AuthParams.global_dashboard_brands
  );
  const global_dashboard_single_brands = useSelector(
    (state) => state.AuthParams.global_dashboard_single_brands
  );
  const brands = useSelector(
    (state) => state.ApiCall.brands?.data?.result?.brands
  );
  const graphConditionConfig = useSelector(
    (state) => state?.apiCall?.graphConditions
  );
  const All_WM_attributes = useSelector(
    (state) => state.WidgetMaker.All_WM_attributes
  );
  const widgetGraphConfigState = useSelector(
    (state) => state?.GraphConfig?.widgetGraphConfig
  );
  const screen = useSelector((state) => state?.Screens?.screen);
  const deepdiveDashboardData = useSelector(
    (state) => state?.DeepDiveDashboard?.dashboardData
  );
  const deepdiveDashboardTemplateData = useSelector(
    (state) => state?.DeepDiveDashboard?.dashboardTemplateData
  );
  const workspace_privileges = useSelector(
    (state) => state.ApiCall.workspace_privileges
  );
  const share_workspace_privileges = useSelector(
    (state) => state.ApiCall.share_workspace_privileges
  );

  let index = getPaneIndex(panes, activeKey);
  let shareSections = shareTemplateData?.section
    ? shareTemplateData?.section?.[0]
    : shareTemplateData?.sections?.[section_index];

  const isDeepDiveDashboardView = useMemo(() => {
    let pathName = getWindowLocationPath()?.toLowerCase();
    return (
      (authParams?.screen_id
        ? screen?.isDeepDiveDashboard
          ? true
          : false
        : shareableLinkDeepDiveStatus
        ? shareTemplateData?.isDeepDiveDashboard
          ? true
          : false
        : !authParams?.screen_id &&
          !shareBrands &&
          (pathName === "dashboard" || pathName === "pin-dashboard") &&
          !panes?.[getPaneIndex(panes, activeKey)]?.is_widget_maker_open_obj
            ?.open_flag &&
          panes?.[getPaneIndex(panes, activeKey)]?.isDeepDiveDashboard
        ? true
        : false) && !deepdiveDashboardTemplateData?.isDeepDive
    );
  }, [
    screen,
    shareTemplateData,
    panes,
    authParams,
    deepdiveDashboardTemplateData,
  ]);

  let widget_metadata = isDeepDiveDashboardView
    ? deepdiveDashboardTemplateData?.sections?.[section_index]?.widgets?.[
        widget_index
      ]
    : authParams?.screen_id
    ? screen?.widgets?.[widget_index]
    : shareBrands
    ? shareSections?.widgets?.[widget_index]
    : window.location.pathname?.split("/")?.[1] === "create-dashboard" ||
      window.location.pathname?.split("/")?.[1] === "edit-dashboard"
    ? section_index >= 0 && section_index !== null
      ? Section?.[section_index]?.data?.[widget_index]
      : Section?.[0]?.data?.[widget_index]
    : section_index >= 0 && panes?.[index]?.sections
    ? panes?.[index]?.sections?.[section_index]?.widgets?.[widget_index]
    : panes?.[index]?.section?.[0]?.widgets?.[widget_index];

  let KPIdive = false;
  if (widget_metadata?.deep_dive_id === "template-usage") {
    KPIdive = true;
  } else {
    KPIdive = false;
  }
  let payloadChartSettings = widget_metadata?.payload?.chart?.chart_settings
    ? widget_metadata?.payload?.chart?.chart_settings
    : widget_metadata?.chart?.chart_settings;

  // use useMemo
  let deepdiveTypes = widget_metadata?.x_axis?.config_filters?.length // new condition for deepdiveTypes for jounrney attributes
    ? widget_metadata?.chart?.chart_type === "kpi" &&
      Array.isArray(widget_metadata?.chart?.chart_settings?.cards_settings) &&
      widget_metadata?.chart?.chart_settings?.cards_settings?.length > 0
      ? [
          widget_metadata?.x_axis?.config_filters?.[0]?.attribute,
          ...widget_metadata?.chart?.chart_settings?.cards_settings
            ?.filter((e) => e?.x_axis)
            ?.map((el) => el?.x_axis?.config_filters?.[0]?.attribute),
        ]
      : widget_metadata?.chart?.chart_type === "kpi"
      ? widget_metadata?.x_axis?.config_filters?.[0]?.attribute
      : widget_metadata?.chart?.chart_settings?.cards_settings
          ?.filter((e) => e?.x_axis)
          ?.map((el) => el?.x_axis?.config_filters?.[0]?.attribute)
    : widget_metadata?.chart?.chart_type === "kpi" &&
      Array.isArray(widget_metadata?.chart?.chart_settings?.cards_settings) &&
      widget_metadata?.chart?.chart_settings?.cards_settings?.length > 0
    ? [
        widget_metadata?.x_axis?.attribute,
        ...widget_metadata?.chart?.chart_settings?.cards_settings
          ?.filter((e) => e?.x_axis)
          ?.map((el) => el?.x_axis?.attribute),
      ]
    : widget_metadata?.chart?.chart_type === "kpi"
    ? widget_metadata?.x_axis?.attribute
    : supportedBenchmarkTraceChartTypes?.includes(
        widget_metadata?.chart?.chart_type
      ) &&
      payloadChartSettings?.benchmark_line &&
      payloadChartSettings?.group_line_agg
    ? Array.isArray(payloadChartSettings?.cards_settings) &&
      payloadChartSettings?.cards_settings?.length > 0
      ? [
          widget_metadata?.x_axis?.attribute,
          ...payloadChartSettings?.cards_settings
            ?.filter((e) => e?.x_axis)
            ?.map((el) => el?.x_axis?.attribute),
        ]
      : widget_metadata?.x_axis?.attribute
    : widget_metadata?.chart?.chart_settings?.cards_settings
        ?.filter((e) => e?.x_axis)
        ?.map((el) => el?.x_axis?.attribute);

  const getConfigFilters = (widget_metadata, key) => {
    // cordinates?.from === nodes?.[index]?.id ---> nodes?.[index]?.attribute
    // var = nodes?.[index]?.attribute
    // widget_metadata?.x_axis?.config_filters?.[index]?.attribute || widgetmetadata?.y_axes?.[index]?.config_filters?.[0]?.attribute === var ----> config_filter
    let x_axis_in_widgetMetadata = deepCopy(widget_metadata?.x_axis);
    let y_axis_in_widgetMetadata = deepCopy(widget_metadata?.y_axes);
    let AxisData = [];

    if (
      y_axis_in_widgetMetadata &&
      !y_axis_in_widgetMetadata?.includes(x_axis_in_widgetMetadata)
    ) {
      y_axis_in_widgetMetadata.push(x_axis_in_widgetMetadata);
    } else if (!y_axis_in_widgetMetadata) {
      y_axis_in_widgetMetadata = [x_axis_in_widgetMetadata];
    }
    AxisData = [...y_axis_in_widgetMetadata];

    if (key === "filter") {
      let allConfigFilters = [];
      AxisData.forEach((item) => {
        if (item?.config_filters && Array.isArray(item?.config_filters)) {
          allConfigFilters = allConfigFilters?.concat(item?.config_filters);
        }
      });

      return allConfigFilters;
    }
  };
  const isValueGreaterThanZero = (value) => {
    if (value == null) return false;
    let numericValue;
    if (typeof value === "string") {
      numericValue = parseFloat(value?.replace("%", ""));
    } else if (typeof value === "number") {
      numericValue = value;
    }
    return !isNaN(numericValue) && numericValue > 0;
  };

  const handleKpiDeepdive = (e, data) => {
    if (personalizationSettingsObj?.isPersonalizationPreviewOpen) {
      callNotification(
        "Actions are not allowed while customizing",
        "info",
        40,
        "personalization-preview-notification personalization-preview-mask",
        true
      );
      return;
    }
    if (
      (!authParams?.screen_id &&
        !shareBrands &&
        graphConditionConfig?.template_calender_action_controls?.includes(
          panes[index]?.template_id
        )) ||
      (shareBrands &&
        graphConditionConfig?.template_calender_action_controls?.includes(
          shareTemplateData?.template_id
        ))
    ) {
      callNotification("Deep dive on this dashboard is not available", "error");
      return;
    }
    let isValidValue = isValueGreaterThanZero(data?.value);
    if (
      !(
        graphConditionConfig?.[`default_attrs`]?.page
          ?.map((d) => d?.attribute)
          ?.includes(data?.y_series?.attribute) ||
        data?.y_series?.data_source === "page"
      ) &&
      (isValidValue || KPIdive) && //confirm this
      data?.value !== null &&
      data?.[`deep-dive`] !== false &&
      (panes[getPaneIndex(panes, activeKey)]?.isDashboard ||
        shareBrands ||
        isDeepDiveDashboardView) &&
      !graphConditionConfig?.common
        ?.map((d) => d?.attribute)
        ?.includes(widget_metadata?.y_series?.[0]?.attribute)
    ) {
      let dashboardDataOfDeepDive = deepdiveDashboardData;
      let deepdiveTemplatData = deepdiveDashboardTemplateData;
      let sectionData = isDeepDiveDashboardView
        ? deepdiveTemplatData?.sections?.[section_index]
        : null;

      let shareSections = shareTemplateData?.section
        ? shareTemplateData?.section?.[0]
        : shareTemplateData?.sections?.[section_index];

      let widget_metadata = isDeepDiveDashboardView
        ? sectionData?.widgets?.[widget_index]
        : shareBrands
        ? shareSections?.widgets?.[widget_index]
        : section_index >= 0 && panes[index]?.sections
        ? panes[index]?.sections?.[section_index]?.widgets?.[widget_index]
        : panes[index]?.section?.[0]?.widgets?.[widget_index];

      let section_metadata = isDeepDiveDashboardView
        ? sectionData
        : shareBrands
        ? shareSections
        : section_index >= 0
        ? panes[index]?.sections[section_index]
        : panes[index]?.section[0];
      let Section_is_locked = section_metadata?.is_locked;
      let widgets_is_locked = widget_metadata?.is_locked;
      let twoMonthsDuration = getCustomizedDate(6, "Days");
      let defaultDuration = {
        from:
          moment(twoMonthsDuration?.date[0]).format("YYYY/MM/DD") +
          " " +
          twoMonthsDuration?.time?.startTime,
        to:
          moment(twoMonthsDuration?.date[1]).format("YYYY/MM/DD") +
          " " +
          twoMonthsDuration?.time?.endTime,
      };
      let widget_ids = [];
      widget_ids = KPIdive
        ? "template_usage"
        : widget_metadata?.data_source === "mentions" &&
          (graphConditionConfig?.["workflow-attrs"]?.includes(
            widget_metadata?.x_axis?.attribute
          ) ||
            graphConditionConfig?.["workflow-attrs"]?.includes(
              widget_metadata?.y_series?.[0]?.attribute
            ))
        ? ["8.1"]
        : widget_metadata?.ticket_deep_dive &&
          widget_metadata?.data_source === "ticket"
        ? ["9.1"]
        : widget_metadata?.data_source === "tickets"
        ? ["6.1"]
        : workspace_privileges?.environment === 2 ||
          share_workspace_privileges?.environment === 2
        ? ["info-bar", "2.1", "2.2", "2.3", "2.4"]
        : ["info-bar", "1.1", "1.2"];

      !shareBrands &&
        dispatch(
          setSelectedDeepdiveWidget(section_index, widget_index, panes, index)
        );

      shareBrands &&
        dispatch(
          setShareSelectedDeepdiveWidget({
            section_index: section_index,
            widget_index: widget_index,
          })
        );

      let global_duration = isDeepDiveDashboardView
        ? dashboardDataOfDeepDive?.start_date
          ? {
              from: dashboardDataOfDeepDive?.start_date,
              to: dashboardDataOfDeepDive?.end_date,
            }
          : null
        : shareBrands
        ? sharedDuration?.from
          ? {
              from: sharedDuration?.from,
              to: sharedDuration?.to,
            }
          : null
        : panes[index]?.duration;

      // let global_brands = shareBrands
      //   ? shareBrands
      //   : getGlobalBrands(
      //       panes[index]?.brands,
      //       global_dashboard_single_brands,
      //       global_dashboard_brands,
      //       panes[index]?.template_type
      //     );
      let global_brands = isDeepDiveDashboardView
        ? dashboardDataOfDeepDive?.brands
        : shareBrands
        ? shareBrands
        : panes?.[index]?.brands;
      let brandIds =
        shareBrands || isDeepDiveDashboardView
          ? widget_metadata?.brand_ids
          : section_index >= 0
          ? panes[index]?.sections[section_index]?.widgets &&
            panes[index]?.sections[section_index]?.widgets[widget_index]
              ?.brand_ids
          : panes[index]?.section[0]?.widgets[widget_index]?.brand_ids
          ? panes[index]?.section[0]?.widgets[widget_index]?.brand_ids
          : null;

      let sectionDateFilter = shareTemplateData?.sections
        ? {
            from: shareTemplateData?.sections[section_index]?.start_date
              ? shareTemplateData?.sections[section_index]?.start_date
              : null,
            to: shareTemplateData?.sections[section_index]?.end_date
              ? shareTemplateData?.sections[section_index]?.end_date
              : null,
          }
        : null;

      let widgetFilterDate = {
        from: widget_metadata?.start_date ? widget_metadata?.start_date : null,
        to: widget_metadata?.end_date ? widget_metadata?.end_date : null,
      };

      let combinedFilters = [];
      if (!widget_metadata?.is_locked) {
        if (widgetFilterDate?.from)
          combinedFilters.push({
            attribute: "CreatedDate",
            type: "datetime",
            columns: widgetFilterDate,
          });

        if (sectionDateFilter?.from && !section_metadata?.is_locked) {
          combinedFilters.push({
            attribute: "CreatedDate",
            type: "datetime",
            columns: sectionDateFilter,
          });
        }
        if (section_metadata?.brand_ids && !section_metadata?.is_locked) {
          let brandsForFilter = shareBrands
            ? getBrands(
                shareBrands?.brand_groups,
                section_metadata?.brand_ids,
                shareBrands?.brand_list,
                section_metadata?.brand_groups
              )
            : getBrands(
                brandlogicalgroup,
                section_metadata?.brand_ids,
                brands,
                section_metadata?.brand_groups
              );

          combinedFilters.push(brandsForFilter);
        }
        if (widget_metadata?.brand_ids) {
          let brandsForFilter = shareBrands
            ? getBrands(
                shareBrands?.brand_groups,
                widget_metadata?.brand_ids,
                shareBrands?.brand_list,
                widget_metadata?.brand_groups
              )
            : getBrands(
                brandlogicalgroup,
                widget_metadata?.brand_ids,
                brands,
                widget_metadata?.brand_groups
              );

          combinedFilters.push(brandsForFilter);
        }
      }

      if (widget_metadata?.filters)
        combinedFilters = [...widget_metadata?.filters, ...combinedFilters];
      if (section_metadata?.filters)
        combinedFilters = [...section_metadata?.filters, ...combinedFilters];
      let filterData = combinedFilters?.filter((d) => d);
      let hidden_filter = shareTemplateData?.hidden_filter
        ? [shareTemplateData?.hidden_filter]
        : [];
      let quick_filter = shareTemplateData?.quick_filter
        ? [shareTemplateData?.quick_filter]
        : [];
      let widgetObj = {
        brand_groups: widget_metadata?.brand_groups,
        singleBrands: brands,
      };
      let brandsContainter = {
        brand_ids: widget_metadata?.brand_ids,
        brand_groups: widget_metadata?.brand_groups,
        singleBrands: shareBrands ? shareBrands?.brand_list : brands,
        brandGroupList: shareBrands
          ? shareBrands?.brand_groups
          : brandlogicalgroup,
      };

      let filter = isDeepDiveDashboardView
        ? getAllDeepDiveDashboardFilters(
            graphConditionConfig,
            deepdiveDashboardData,
            deepdiveDashboardTemplateData,
            section_index,
            widget_index,
            brandsContainter
          )
        : shareBrands
        ? getAllShareFilters(
            graphConditionConfig,
            shareTemplateData,
            section_index,
            widget_index,
            shareBrands
          )
        : getAllFilters(
            graphConditionConfig,
            panes,
            index,
            section_index,
            widget_index,
            brandlogicalgroup,
            brandIds,
            widgetObj
          );

      let widget_brands = shareBrands
        ? getBrands(
            shareBrands?.brand_groups,
            widget_metadata?.brand_ids,
            shareBrands?.brand_list,
            widget_metadata?.brand_groups
          )
        : getBrands(
            brandlogicalgroup,
            widget_metadata?.brand_ids,
            brands,
            widget_metadata?.brand_groups
          );
      let section_brands = shareBrands
        ? getBrands(
            shareBrands?.brand_groups,
            section_metadata?.brand_ids,
            shareBrands?.brand_list,
            section_metadata?.brand_groups
          )
        : getBrands(
            brandlogicalgroup,
            section_metadata?.brand_ids,
            brands,
            section_metadata?.brand_groups
          );
      let defaultBrands = isDeepDiveDashboardView
        ? dashboardDataOfDeepDive?.brands
        : shareBrands
        ? shareBrands
        : null;

      // This case is applied when we select competition brand and applied competition filter(Owned/Competition)
      // calculating brand in case of section comprtiotion brand type exists

      let sectionComprtitorBrandType =
        section_metadata?.comp_brand_type === false ||
        section_metadata?.comp_brand_type === true
          ? section_metadata?.comp_brand_type
          : null;
      let sectionComprtitorBrandTypeExists =
        sectionComprtitorBrandType === false ||
        sectionComprtitorBrandType === true;
      let globalBrandChangeInShare = false;
      let updatedComBrandList = [];
      if (
        !(Section_is_locked && section_brands?.columns?.length) &&
        sectionComprtitorBrandTypeExists
      ) {
        if (shareBrands) {
          let comBrand = defaultBrands?.brands?.columns?.[0]?.competitor
            ? defaultBrands?.brands?.columns?.[0]
            : defaultBrands?.brands?.[0]?.competitor
            ? defaultBrands?.brands?.[0]
            : defaultBrands?.brands?.competitor
            ? defaultBrands?.brands
            : null;
          let comBrandExists = comBrand?.competitor
            ? true
            : defaultBrands
            ? defaultBrands?.selected_brand_ids?.length &&
              defaultBrands?.selected_comp_brand_ids?.length > 0
            : null;
          if (comBrandExists) {
            if (comBrand) {
              if (sectionComprtitorBrandType === false) {
                updatedComBrandList.push({
                  brand_id: comBrand?.name,
                  brand_name: comBrand?.brand_name,
                  brand_friendly_name: comBrand?.brand_friendly_name,
                });
              } else {
                comBrand?.competitorList?.forEach((competitorBrand) => {
                  updatedComBrandList.push(competitorBrand);
                });
              }
              globalBrandChangeInShare = true;
            } else {
              if (sectionComprtitorBrandType === false) {
                let parentB = defaultBrands?.selected_brand_ids?.[0];
                updatedComBrandList.push({
                  brand_id: parentB?.brand_id,
                  brand_name: parentB?.brand_name,
                  brand_friendly_name: parentB?.brand_friendly_name,
                });
              } else {
                defaultBrands?.selected_comp_brand_ids?.forEach(
                  (competitorBrand) => {
                    updatedComBrandList.push(competitorBrand);
                  }
                );
              }
            }
          } else {
            sectionComprtitorBrandTypeExists = false;
          }
        } else {
          let comBrand = global_brands?.columns?.[0]?.competitor
            ? global_brands?.columns?.[0]
            : global_brands?.[0]?.competitor
            ? global_brands?.[0]
            : global_brands?.competitor
            ? global_brands
            : null;
          if (comBrand?.competitor) {
            if (sectionComprtitorBrandType === false) {
              updatedComBrandList.push({
                brand_id: comBrand?.name,
                brand_name: comBrand?.brand_name,
                brand_friendly_name: comBrand?.brand_friendly_name,
              });
            } else {
              comBrand?.competitorList?.forEach((competitorBrand) => {
                updatedComBrandList.push(competitorBrand);
              });
            }
          } else {
            sectionComprtitorBrandTypeExists = false;
          }
        }
      }
      let benchmark_static_value = null;
      let payloadChartSettings = widget_metadata?.payload?.chart?.chart_settings
        ? widget_metadata?.payload?.chart?.chart_settings
        : widget_metadata?.chart?.chart_settings;
      if (
        supportedBenchmarkTraceChartTypes?.includes(
          widget_metadata?.chart?.chart_type
        ) &&
        payloadChartSettings?.benchmark_line &&
        payloadChartSettings?.group_line_agg
      ) {
        let firstKpiData = kpi_data?.[0];
        benchmark_static_value = firstKpiData?.value;
      }
      // here calculating the public_engagement_only for the deepdive
      let public_engagement_only =
        pathName === "CommandCenter"?.toLowerCase() || isDeepDiveDashboardView
          ? false // for now static false sending for command center
          : shareBrands
          ? shareTemplateData?.template_type === "competition"
            ? shareTemplateData?.public_engagement_only || false
            : false
          : panes?.[index]?.template_type === "competition"
          ? panes?.[index]?.public_engagement_only || false
          : false;
      let graphObject = {
        account_list: widget_metadata?.payload?.account_list
          ? widget_metadata?.payload?.account_list
          : null,
        start_date: widgets_is_locked
          ? widget_metadata?.start_date
            ? widget_metadata?.start_date
            : global_duration?.from
            ? global_duration?.from
            : defaultDuration?.from
          : Section_is_locked
          ? section_metadata.start_date
            ? section_metadata?.start_date
            : global_duration?.from
            ? global_duration?.from
            : defaultDuration?.from
          : global_duration?.from
          ? global_duration?.from
          : defaultDuration?.from,
        end_date: widgets_is_locked
          ? widget_metadata?.end_date
            ? widget_metadata?.end_date
            : global_duration?.to
            ? global_duration?.to
            : defaultDuration?.to
          : Section_is_locked
          ? section_metadata?.end_date
            ? section_metadata?.end_date
            : global_duration?.to
            ? global_duration?.to
            : defaultDuration?.to
          : global_duration?.to
          ? global_duration?.to
          : defaultDuration?.to,
        brands: shareBrands
          ? widget_metadata?.is_locked
            ? widget_brands?.columns
              ? widget_brands?.columns
              : section_metadata?.is_locked
              ? section_brands?.columns
                ? section_brands?.columns
                : widget_metadata?.duplicate_for_brands
                ? widget_metadata?.com_brand_ids
                : sectionComprtitorBrandTypeExists
                ? updatedComBrandList
                : defaultBrands
              : widget_metadata?.duplicate_for_brands
              ? widget_metadata?.com_brand_ids
              : sectionComprtitorBrandTypeExists
              ? updatedComBrandList
              : defaultBrands
            : section_metadata?.is_locked
            ? section_brands?.columns
              ? section_brands?.columns
              : widget_metadata?.duplicate_for_brands
              ? widget_metadata?.com_brand_ids
              : sectionComprtitorBrandTypeExists
              ? updatedComBrandList
              : defaultBrands
            : widget_metadata?.duplicate_for_brands
            ? widget_metadata?.com_brand_ids
            : sectionComprtitorBrandTypeExists
            ? updatedComBrandList
            : defaultBrands
          : widgets_is_locked
          ? widget_metadata?.brand_ids || widget_metadata?.brand_groups
            ? widget_brands?.columns
            : Section_is_locked
            ? section_metadata?.brand_ids || section_metadata?.brand_groups
              ? section_brands?.columns
              : widget_metadata?.duplicate_for_brands
              ? widget_metadata?.com_brand_ids
              : sectionComprtitorBrandTypeExists
              ? updatedComBrandList
              : global_brands
              ? global_brands
              : brandlogicalgroup?.length > 0
              ? brandlogicalgroup
              : brands
            : widget_metadata?.duplicate_for_brands
            ? widget_metadata?.com_brand_ids
            : sectionComprtitorBrandTypeExists
            ? updatedComBrandList
            : global_brands
            ? global_brands
            : brandlogicalgroup?.length > 0
            ? brandlogicalgroup
            : brands
          : Section_is_locked
          ? section_metadata?.brand_ids || section_metadata?.brand_groups
            ? section_brands?.columns
            : widget_metadata?.duplicate_for_brands
            ? widget_metadata?.com_brand_ids
            : sectionComprtitorBrandTypeExists
            ? updatedComBrandList
            : global_brands
            ? global_brands
            : brandlogicalgroup?.length > 0
            ? brandlogicalgroup
            : brands
          : widget_metadata?.duplicate_for_brands
          ? widget_metadata?.com_brand_ids
          : sectionComprtitorBrandTypeExists
          ? updatedComBrandList
          : global_brands
          ? global_brands
          : brandlogicalgroup?.length > 0
          ? brandlogicalgroup
          : brands,
        // isBrandModified:
        //   !shareBrands &&
        //   (widgets_is_locked || Section_is_locked) &&
        //   (section_metadata?.brand_ids ||
        //     section_metadata?.brand_groups ||
        //     widget_metadata?.brand_ids ||
        //     widget_metadata?.brand_groups)
        //     ? true
        //     : global_brands
        //     ? true
        //     : false,
        deepdive_on: {
          x_axis: {
            attribute: data?.attribute,
            value: KPIdive
              ? data?.value
              : data?.text?.includes("|$|")
              ? data?.text?.split("|$|")?.[1]?.trim()
              : data?.text?.includes("|G|")
              ? data?.text?.split("|G|")?.[1]?.trim()
              : data?.text?.includes("|C|")
              ? data?.text?.split("|C|")?.[1]?.trim()
              : data?.text,
            trace_name: KPIdive
              ? data?.text
              : data?.trace_name
              ? data?.trace_name
              : allAttributes[data?.attribute],
            date_part:
              widget_metadata?.x_axis?.date_part &&
              widget_metadata?.x_axis?.date_part !== "D"
                ? widget_metadata?.x_axis?.date_part
                : widget_metadata?.x_axis?.date_aggregation,
            special_cases:
              widget_metadata?.x_axis?.special_cases ||
              widget_metadata?.special_cases,
          },
          y_series: data?.y_series
            ? {
                ...data?.y_series,
                value: data?.value,
                trace_name: data?.y_series?.trace_name
                  ? data?.y_series?.trace_name
                  : allAttributes[data?.y_series?.attribute]
                  ? allAttributes[data?.y_series?.attribute]
                  : "",
              }
            : null,
          benchmark_static_value: benchmark_static_value,
        },
        combined_config_filters: getConfigFilters(widget_metadata, "filter"),

        filters: filter ? filter : null,
        shareCategory: shareCategory,
        filter_by: widget_metadata?.payload?.filter_by,
        filter_dropdown: widget_metadata?.payload?.filter_dropdown || [],
        filter_by_dropdown: widget_metadata?.payload?.filter_by_dropdown || [],
        isTicketBased:
          widget_ids?.includes("6.1") || widget_ids?.includes("9.1"),
        ticketDeepDiveWidgetId: widget_ids?.includes("9.1")
          ? "9.1"
          : widget_ids?.includes("6.1")
          ? "6.1"
          : null,
        isWorkFlowBased: widget_ids?.includes("8.1"),
        public_engagement_only: public_engagement_only ? true : false,
      };
      graphObject.isSectionCompetitorBrandTypeExists = (() => {
        // Return false if any of these conditions are true
        if (
          widget_metadata?.duplicate_for_brands ||
          (shareBrands &&
            widget_metadata?.is_locked &&
            widget_brands?.columns) ||
          (shareBrands &&
            section_metadata?.is_locked &&
            section_brands?.columns) ||
          (!shareBrands &&
            widgets_is_locked &&
            (widget_metadata?.brand_ids || widget_metadata?.brand_groups)) ||
          (!shareBrands &&
            Section_is_locked &&
            (section_metadata?.brand_ids || section_metadata?.brand_groups))
        ) {
          return false;
        }

        // Return true only if sectionComprtitorBrandTypeExists is true and globalBrandChangeInShare is true
        return (
          (sectionComprtitorBrandTypeExists && globalBrandChangeInShare) ||
          false
        );
      })();
      graphObject.isBrandModified =
        !shareBrands &&
        (global_brands ||
          (widgets_is_locked &&
            (widget_brands?.columns
              ? widget_brands?.columns?.length
              : widget_brands?.length)) ||
          (Section_is_locked &&
            (section_brands?.columns
              ? section_brands?.columns?.length
              : section_brands?.length)) ||
          widget_metadata?.duplicate_for_brands)
          ? true
          : false;
      let deepDiveInfo = data?.deep_dive_info;
      if (
        deepDiveInfo?.template_id &&
        Array.isArray(deepDiveInfo?.template_id)
      ) {
        let templateId = deepDiveInfo?.template_id?.[0];
        graphObject.template_id = templateId;
        // If brands are by default share brand then need to pass here global brands as dashboard format
        // recalculate
        if (shareBrands) {
          if (
            graphObject?.brands &&
            (graphObject?.brands?.selected_brand_ids?.length > 0 ||
              graphObject?.brands?.selected_brand_groups?.length > 0)
          ) {
            if (graphObject?.brands?.brands?.columns?.length > 0) {
              graphObject.brands = graphObject?.brands?.brands;
            } else if (
              (graphObject?.brands?.selected_brand_ids?.length > 0 ||
                graphObject?.brands?.selected_brand_groups?.length > 0) &&
              !(
                graphObject?.brands?.selected_comp_brand_ids &&
                graphObject?.brands?.selected_comp_brand_ids?.length
              )
            ) {
              // to calculate normal single brand and brand groups
              let selectedBrands = getBrands(
                shareBrands?.brand_groups,
                graphObject?.brands?.selected_brand_ids,
                shareBrands?.brand_list,
                graphObject?.brands?.selected_brand_groups
              );
              graphObject.brands = selectedBrands;
            } else if (
              graphObject?.brands?.selected_brand_ids?.length > 0 &&
              graphObject?.brands?.selected_comp_brand_ids &&
              graphObject?.brands?.selected_comp_brand_ids?.length
            ) {
              let parentB = graphObject?.brands?.selected_brand_ids?.[0];

              let selectedCompBrand = {
                attribute: "BrandID",
                type: "varchar",
                columns: [
                  {
                    group: false,
                    name: parentB?.brand_id,
                    brand_name: parentB?.brand_name,
                    brand_friendly_name: parentB?.brand_friendly_name,
                    type: "include",
                    brand_group_name: false,
                    competitor: true,
                    competitorList:
                      graphObject?.brands?.selected_comp_brand_ids,
                  },
                ],
              };
              graphObject.brands = selectedCompBrand;
            }
          }
        }
        // if this is second level deepdive so need to pass sub_deep_dive_on key
        // where old deepdive_on object will pass and new one is same as

        if (
          deepdive_object?.deepdive_on ||
          deepdiveDashboardData?.deepdive_on
        ) {
          let newDeepDiveOnObject = graphObject?.deepdive_on;

          let mentionDeepDiveOnObject = deepdive_object?.deepdive_on
            ? { ...deepdive_object?.deepdive_on }
            : null;
          mentionDeepDiveOnObject = mentionDeepDiveOnObject
            ? deepCopy(mentionDeepDiveOnObject)
            : null;

          let deediveDashboardOnObject = deepdiveDashboardData?.deepdive_on
            ? { ...deepdiveDashboardData?.deepdive_on }
            : null;
          deediveDashboardOnObject = deediveDashboardOnObject
            ? deepCopy(deediveDashboardOnObject)
            : null;

          let sub_deep_dive_on = [];
          if (
            deepdive_object?.sub_deep_dive_on &&
            Array.isArray(deepdive_object.sub_deep_dive_on)
          ) {
            sub_deep_dive_on = [
              ...sub_deep_dive_on,
              ...deepdive_object.sub_deep_dive_on,
            ];
          }
          if (
            deepdiveDashboardData?.sub_deep_dive_on &&
            Array.isArray(deepdiveDashboardData.sub_deep_dive_on)
          ) {
            sub_deep_dive_on = [
              ...sub_deep_dive_on,
              ...deepdiveDashboardData.sub_deep_dive_on,
            ];
          }
          if (mentionDeepDiveOnObject) {
            sub_deep_dive_on.push(mentionDeepDiveOnObject);
          }
          if (deediveDashboardOnObject) {
            sub_deep_dive_on.push(deediveDashboardOnObject);
          }
          graphObject.sub_deep_dive_on =
            sub_deep_dive_on &&
            Array.isArray(sub_deep_dive_on) &&
            sub_deep_dive_on?.length > 0
              ? [...sub_deep_dive_on]
              : null;
        }
        // if (pathName === "CommandCenter"?.toLowerCase()) {
        //   // For Command Center, we need to set the deep dive object
        //   dispatch(setScreenIsDeepDiveDashboard(true));
        // } else
        if (shareBrands) {
          // For Share Dashboard, we need to set the deep dive object
          shareTemplateData &&
            dispatch({
              type: "SET_SHARE_TEMPLATE_DATA",
              payload: {
                ...shareTemplateData,
                isDeepDiveDashboard: true,
              },
            });
        } else {
          dispatch(setIsDeepDiveDashboard(true, index));
        }
        dispatch(setInitialDeepDiveDashboardData(graphObject));
      } else {
        graphObject.paneIndex = index;
        graphObject.panes = panes;
        graphObject.shareBrands = shareBrands;
        graphObject.shareTemplateData = {
          ...shareTemplateData,
          isDeepDive: true,
          deep_dive: {
            infoBar: null,
            mentions: null,
            wordcloud: [],
            category: [],
            top_users: [],
            influencers: [],
            source_of_post: [],
            locations: [],
          },
        };
        graphObject.tabName =
          workspace_privileges?.environment === 2 ||
          share_workspace_privileges?.environment === 2
            ? "Word Cloud"
            : "Mentions";
        if (isDeepDiveDashboardView) {
          dispatch(setIsDeepDiveInDashboardTemplateData(true)); // to indicate second level deepdive is opened

          // if this is second level deepdive so need to pass sub_deep_dive_on key
          // where old deepdive_on object will pass and new one is same as

          if (deepdiveDashboardData?.deepdive_on) {
            let newDeepDiveOnObject = graphObject?.deepdive_on;
            let deediveDashboardOnObject = deepdiveDashboardData?.deepdive_on
              ? { ...deepdiveDashboardData?.deepdive_on }
              : null;
            deediveDashboardOnObject = deediveDashboardOnObject
              ? deepCopy(deediveDashboardOnObject)
              : null;

            let sub_deep_dive_on = [];
            if (
              deepdiveDashboardData?.sub_deep_dive_on &&
              Array.isArray(deepdiveDashboardData.sub_deep_dive_on)
            ) {
              sub_deep_dive_on = [
                ...sub_deep_dive_on,
                ...deepdiveDashboardData.sub_deep_dive_on,
              ];
            }

            if (deediveDashboardOnObject) {
              sub_deep_dive_on.push(deediveDashboardOnObject);
            }
            graphObject.sub_deep_dive_on =
              sub_deep_dive_on &&
              Array.isArray(sub_deep_dive_on) &&
              sub_deep_dive_on?.length > 0
                ? [...sub_deep_dive_on]
                : null;
          }
        }
        dispatch(
          setIsDetailedInsightVisible({
            value: false,
            tab_id: null,
            name:
              workspace_privileges?.environment === 2 ||
              share_workspace_privileges?.environment === 2
                ? "Word Cloud"
                : "Mentions",
            key:
              workspace_privileges?.environment === 2 ||
              share_workspace_privileges?.environment === 2
                ? "2"
                : "1",
          })
        );

        dispatch(
          setTabClick({
            tabName:
              workspace_privileges?.environment === 2 ||
              share_workspace_privileges?.environment === 2
                ? "wordcloud"
                : "mentions",
            state: true,
          })
        );
        dispatch(setDeepDiveObject(graphObject));
        dispatch(setDeepDiveMentionsObject(graphObject));
        dispatch(setDeepDiveInfluencersObject(graphObject));
        shareTemplateData &&
          dispatch({
            type: "SET_SHARE_TEMPLATE_DATA",
            payload: {
              ...shareTemplateData,
              isDeepDive: true,
              deep_dive: {
                infoBar: null,
                mentions: null,
                wordcloud: [],
                category: [],
                top_users: [],
                influencers: [],
                source_of_post: [],
                locations: [],
              },
            },
          });
        !shareBrands && dispatch(setisDeepDive(true, panes, index));

        dispatch(set_WM_DeepDive(true));
        dispatch(setDeepDiveInfoLoader(true));
        dispatch(
          getDeepDive(
            authParams,
            graphObject,
            widget_ids,
            query?.get("share_id")
          )
        );
        dispatch(setOptionHighChart(null));
        dispatch(setupdatedGraphData({}));
      }
    }
  };

  const TooltipFormatter = (num) => {
    if (Math.abs(num)) {
      return (Math.round(num * 100) / 100).toFixed(2)?.toLocaleString();
    } else return num;
  };

  const getcardData = () => {
    let cData =
      widgetGraphConfig?.brands && widgetGraphConfig?.brands[0]?.competitor
        ? widgetGraphConfig?.card_settings &&
          widgetGraphConfig?.card_settings[
            widgetGraphConfig?.card_settings?.length - 1
          ]?.response
        : (widgetGraphConfig?.card_settings &&
            widgetGraphConfig?.card_settings[
              widgetGraphConfig?.card_settings?.length - 1
            ]?.x_axis?.atrribute) ||
          (widgetGraphConfig?.card_settings &&
            widgetGraphConfig?.card_settings[
              widgetGraphConfig?.card_settings?.length - 1
            ]?.y_series) ||
          (widgetGraphConfig?.card_settings &&
            widgetGraphConfig?.card_settings[
              widgetGraphConfig?.card_settings?.length - 1
            ]?.response)
        ? widgetGraphConfig?.card_settings &&
          widgetGraphConfig?.card_settings[
            widgetGraphConfig?.card_settings?.length - 1
          ]?.response
        : widgetGraphConfig?.card_settings &&
          widgetGraphConfig?.card_settings[
            widgetGraphConfig?.card_settings?.length - 2
          ]?.response;
    return cData;
  };

  const card_data = useMemo(() => getcardData(), [widgetGraphConfigState]);

  if (cardPosition == undefined) cardPosition = "";

  const isAdsCampaignDashboard = shareableLinkDeepDiveStatus
    ? shareTemplateData?.quick_filter?.attribute === "Ads_Campaign"
    : panes[getPaneIndex(panes, activeKey)]?.quick_filter === "Ads_Campaign";

  const isDeepDive = isAdsCampaignDashboard
    ? false
    : authParams?.screen_id
    ? screen?.isDeepDiveDashboard && !screen?.isDeepDive
      ? deepdiveDashboardTemplateData?.template_type === "deep_dive"
      : !screen?.isDeepDive
    : shareableLinkDeepDiveStatus
    ? shareTemplateData?.isDeepDiveDashboard && !shareTemplateData?.isDeepDive
      ? deepdiveDashboardTemplateData?.template_type === "deep_dive"
      : !shareTemplateData?.isDeepDive
    : panes[getPaneIndex(panes, activeKey)]?.isDeepDiveDashboard &&
      !panes[getPaneIndex(panes, activeKey)]?.isDeepDive
    ? deepdiveDashboardTemplateData?.template_type === "deep_dive"
    : !panes[getPaneIndex(panes, activeKey)]?.isDeepDive;

  let flrSeriesExists = false;
  metaWidgetConfig?.y_series?.forEach((yseries, index) => {
    if (yseries?.attribute) {
      if (
        yseries?.attribute === "flr" ||
        graphConditionConfig?.["ticket-time-label-attrs"]?.includes(
          // time formatting in KPI
          yseries?.attribute
        )
      ) {
        flrSeriesExists = true;
      }
    } else {
      flrSeriesExists = false;
    }
  });
  const cardSetingsExits = useMemo(() => {
    let chartSettingsOfWidget = widget_metadata
      ? widget_metadata?.payload?.chart?.chart_settings
        ? widget_metadata?.payload?.chart?.chart_settings
        : widget_metadata?.chart?.chart_settings
      : metaWidgetConfig
      ? metaWidgetConfig?.payload?.chart?.chart_settings
        ? metaWidgetConfig?.payload?.chart?.chart_settings
        : metaWidgetConfig?.chart?.chart_settings
      : null;
    return chartSettingsOfWidget
      ? Array.isArray(chartSettingsOfWidget?.cards_settings) &&
          chartSettingsOfWidget?.cards_settings?.length > 0
      : false;
  }, [metaWidgetConfig, widget_metadata]);
  // console.log(
  //   "flrSeriesExists =>",
  //   flrSeriesExists,
  //   kpi_data,
  //   "cardSetingsExits : ",
  //   cardSetingsExits
  // );
  return (
    <>
      {widget_metadata?.y_series?.[0]?.attribute === "roi_workflow" ? (
        <>
          <RoiKpi
            kpi_data={kpi_data?.[0]}
            PdfDownloadStatus={PdfDownloadStatus}
            ppt_generating_status={ppt_generating_status}
            isPreviewState={isPreviewState}
            widgetMetaData={widget_metadata}
            section_index={section_index}
            widget_index={widget_index}
            isDeepDiveDashboardView={isDeepDiveDashboardView}
          />
        </>
      ) : (
        <>
          {authParams?.screen_id === "000-000-556" &&
          !isDeepDiveDashboardView ? (
            <>
              <div className="row w-100" style={{ paddingLeft: "0.5rem" }}>
                <div
                  className="col-4 w-100 d-flex m-0 p-15 pl-15"
                  style={{
                    // backgroundColor: "#ccffff",
                    textAlign: "center",
                  }}
                >
                  <div className="w-100">
                    <div className="wm-chart-card-title-campaign mb-1 line-height-normal">
                      <Tooltip
                        title={kpi_data?.[0]?.text}
                        placement="top"
                        className="text-ellipsis d-inline-block wm-chart-card-title-campaign"
                      >
                        <span style={{ color: kpi_data?.[0]?.text_color }}>
                          {kpi_data?.[0]?.text?.length >= 40
                            ? `${kpi_data?.[0]?.text.substring(0, 40)}...`
                            : kpi_data?.[0]?.text}
                        </span>
                      </Tooltip>
                    </div>
                    <div
                      style={{
                        display: "block !important",
                        textAlign: "center",
                      }}
                    >
                      <Tooltip
                        placement="bottom"
                        title={
                          kpi_data?.[0]?.value
                            ? TooltipFormatter(kpi_data?.[0]?.value)
                            : ""
                        }
                        style={{ whiteSpace: "nowrap" }}
                      >
                        <span
                          className={`${
                            kpi_data?.[0]?.text_color !== "#000000"
                              ? "wm-chart-card-value-color"
                              : "wm-chart-card-value"
                          } mr-1 no--wrap`}
                          style={
                            kpi_data?.[0]?.text_color !== "#000000"
                              ? { color: kpi_data?.[0]?.text_color }
                              : {}
                          }
                        >
                          {kpi_data?.[0]?.value === null
                            ? "NA"
                            : kFormatter(kpi_data?.[0]?.value, true)}
                        </span>
                      </Tooltip>
                    </div>
                  </div>
                  <div
                    className="w-100"
                    style={{ borderRight: "0.1rem solid lightgrey" }}
                  >
                    <div className="wm-chart-card-title-campaign mb-1 line-height-normal">
                      <Tooltip
                        title={kpi_data?.[1]?.text}
                        placement="top"
                        className="text-ellipsis d-inline-block wm-chart-card-title-campaign"
                      >
                        <span style={{ color: kpi_data?.[1]?.text_color }}>
                          {kpi_data?.[1]?.text?.length >= 40
                            ? `${kpi_data?.[1]?.text.substring(0, 40)}...`
                            : kpi_data?.[1]?.text}
                        </span>
                      </Tooltip>
                    </div>
                    <div
                      style={{
                        display: "block !important",
                        textAlign: "center",
                      }}
                    >
                      <Tooltip
                        placement="bottom"
                        title={
                          kpi_data?.[1]?.value
                            ? TooltipFormatter(kpi_data?.[1]?.value)
                            : ""
                        }
                        style={{ whiteSpace: "nowrap" }}
                      >
                        <span
                          className={`${
                            kpi_data?.[1]?.text_color !== "#000000"
                              ? "wm-chart-card-value-color"
                              : "wm-chart-card-value"
                          } mr-1 no--wrap`}
                          style={
                            kpi_data?.[1]?.text_color !== "#000000"
                              ? { color: kpi_data?.[1]?.text_color }
                              : {}
                          }
                        >
                          {kpi_data?.[1]?.value === null
                            ? "NA"
                            : kFormatter(kpi_data?.[1]?.value, true)}
                        </span>
                      </Tooltip>
                    </div>
                  </div>
                </div>
                <div
                  className="col-4 w-100 d-flex m-0 p-15"
                  style={{
                    // backgroundColor: "#d4d4f7",
                    textAlign: "center",
                  }}
                >
                  <div className="w-100">
                    <div className="wm-chart-card-title-campaign mb-1 line-height-normal">
                      <Tooltip
                        title={kpi_data?.[2]?.text}
                        placement="top"
                        className="text-ellipsis d-inline-block wm-chart-card-title-campaign"
                      >
                        <span style={{ color: kpi_data?.[2]?.text_color }}>
                          {kpi_data?.[2]?.text?.length >= 40
                            ? `${kpi_data?.[2]?.text.substring(0, 40)}...`
                            : kpi_data?.[2]?.text}
                        </span>
                      </Tooltip>
                    </div>
                    <div
                      style={{
                        display: "block !important",
                        textAlign: "center",
                      }}
                    >
                      <Tooltip
                        placement="bottom"
                        title={
                          kpi_data?.[2]?.value
                            ? TooltipFormatter(kpi_data?.[2]?.value)
                            : ""
                        }
                        style={{ whiteSpace: "nowrap" }}
                      >
                        <span
                          className={`${
                            kpi_data?.[2]?.text_color !== "#000000"
                              ? "wm-chart-card-value-color"
                              : "wm-chart-card-value"
                          } mr-1 no--wrap`}
                          style={
                            kpi_data?.[2]?.text_color !== "#000000"
                              ? { color: kpi_data?.[2]?.text_color }
                              : {}
                          }
                        >
                          {kpi_data?.[2]?.value === null
                            ? "NA"
                            : kFormatter(kpi_data?.[2]?.value, true)}
                        </span>
                      </Tooltip>
                    </div>
                  </div>
                  <div className="w-100">
                    <div className="wm-chart-card-title-campaign mb-1 line-height-normal">
                      <Tooltip
                        title={kpi_data?.[3]?.text}
                        placement="top"
                        className="text-ellipsis d-inline-block wm-chart-card-title-campaign"
                      >
                        <span style={{ color: kpi_data?.[3]?.text_color }}>
                          {kpi_data?.[3]?.text?.length >= 40
                            ? `${kpi_data?.[3]?.text.substring(0, 40)}...`
                            : kpi_data?.[3]?.text}
                        </span>
                      </Tooltip>
                    </div>
                    <div
                      style={{
                        display: "block !important",
                        textAlign: "center",
                      }}
                    >
                      <Tooltip
                        placement="bottom"
                        title={
                          kpi_data?.[3]?.value
                            ? TooltipFormatter(kpi_data?.[3]?.value)
                            : ""
                        }
                        style={{ whiteSpace: "nowrap" }}
                      >
                        <span
                          className={`${
                            kpi_data?.[3]?.text_color !== "#000000"
                              ? "wm-chart-card-value-color"
                              : "wm-chart-card-value"
                          } mr-1 no--wrap`}
                          style={
                            kpi_data?.[3]?.text_color !== "#000000"
                              ? { color: kpi_data?.[3]?.text_color }
                              : {}
                          }
                        >
                          {kpi_data?.[3]?.value === null
                            ? "NA"
                            : kFormatter(kpi_data?.[3]?.value, true)}
                        </span>
                      </Tooltip>
                    </div>
                  </div>
                  <div
                    className="w-100"
                    style={{ borderRight: "0.1rem solid lightgrey" }}
                  >
                    <div className="wm-chart-card-title-campaign mb-1 line-height-normal">
                      <Tooltip
                        title={kpi_data?.[4]?.text}
                        placement="top"
                        className="text-ellipsis d-inline-block wm-chart-card-title-campaign"
                      >
                        <span style={{ color: kpi_data?.[4]?.text_color }}>
                          {kpi_data?.[4]?.text?.length >= 40
                            ? `${kpi_data?.[4]?.text.substring(0, 40)}...`
                            : kpi_data?.[4]?.text}
                        </span>
                      </Tooltip>
                    </div>
                    <div
                      style={{
                        display: "block !important",
                        textAlign: "center",
                      }}
                    >
                      <Tooltip
                        placement="bottom"
                        title={
                          kpi_data?.[4]?.value
                            ? TooltipFormatter(kpi_data?.[4]?.value)
                            : ""
                        }
                        style={{ whiteSpace: "nowrap" }}
                      >
                        <span
                          className={`${
                            kpi_data?.[4]?.text_color !== "#000000"
                              ? "wm-chart-card-value-color"
                              : "wm-chart-card-value"
                          } mr-1 no--wrap`}
                          style={
                            kpi_data?.[4]?.text_color !== "#000000"
                              ? { color: kpi_data?.[4]?.text_color }
                              : {}
                          }
                        >
                          {kpi_data?.[4]?.value === null
                            ? "NA"
                            : kFormatter(kpi_data?.[4]?.value, true)}
                        </span>
                      </Tooltip>
                    </div>
                  </div>
                </div>
                <div
                  className="col-4 w-100 d-flex m-0 p-15"
                  style={{
                    // backgroundColor: "#ffccff",
                    textAlign: "center",
                  }}
                >
                  <div className="w-100">
                    <div className="wm-chart-card-title-campaign mb-1 line-height-normal">
                      <Tooltip
                        title={kpi_data?.[5]?.text}
                        placement="top"
                        className="text-ellipsis d-inline-block wm-chart-card-title-campaign"
                      >
                        <span style={{ color: kpi_data?.[5]?.text_color }}>
                          {kpi_data?.[5]?.text?.length >= 40
                            ? `${kpi_data?.[5]?.text.substring(0, 40)}...`
                            : kpi_data?.[5]?.text}
                        </span>
                      </Tooltip>
                    </div>
                    <div
                      style={{
                        display: "block !important",
                        textAlign: "center",
                      }}
                    >
                      <Tooltip
                        placement="bottom"
                        title={
                          kpi_data?.[5]?.value
                            ? TooltipFormatter(kpi_data?.[5]?.value)
                            : ""
                        }
                        style={{ whiteSpace: "nowrap" }}
                      >
                        <span
                          className={`${
                            kpi_data?.[5]?.text_color !== "#000000"
                              ? "wm-chart-card-value-color"
                              : "wm-chart-card-value"
                          } mr-1 no--wrap`}
                          style={
                            kpi_data?.[5]?.text_color !== "#000000"
                              ? { color: kpi_data?.[5]?.text_color }
                              : {}
                          }
                        >
                          {kpi_data?.[5]?.value === null
                            ? "NA"
                            : kFormatter(kpi_data?.[5]?.value, true)}
                        </span>
                      </Tooltip>
                    </div>
                  </div>
                  <div className="w-100">
                    <div className="wm-chart-card-title-campaign mb-1 line-height-normal">
                      <Tooltip
                        title={kpi_data?.[6]?.text}
                        placement="top"
                        className="text-ellipsis d-inline-block wm-chart-card-title-campaign"
                      >
                        <span style={{ color: kpi_data?.[6]?.text_color }}>
                          {kpi_data?.[6]?.text?.length >= 40
                            ? `${kpi_data?.[6]?.text.substring(0, 40)}...`
                            : kpi_data?.[6]?.text}
                        </span>
                      </Tooltip>
                    </div>
                    <div
                      style={{
                        display: "block !important",
                        textAlign: "center",
                      }}
                    >
                      <Tooltip
                        placement="bottom"
                        title={
                          kpi_data?.[6]?.value
                            ? TooltipFormatter(kpi_data?.[6]?.value)
                            : ""
                        }
                        style={{ whiteSpace: "nowrap" }}
                      >
                        <span
                          className={`${
                            kpi_data?.[6]?.text_color !== "#000000"
                              ? "wm-chart-card-value-color"
                              : "wm-chart-card-value"
                          } mr-1 no--wrap`}
                          style={
                            kpi_data?.[6]?.text_color !== "#000000"
                              ? { color: kpi_data?.[6]?.text_color }
                              : {}
                          }
                        >
                          {kpi_data?.[6]?.value === null
                            ? "NA"
                            : kFormatter(kpi_data?.[6]?.value, true)}
                        </span>
                      </Tooltip>
                    </div>
                  </div>
                  <div className="w-100">
                    <div className="wm-chart-card-title-campaign mb-1 line-height-normal">
                      <Tooltip
                        title={kpi_data?.[7]?.text}
                        placement="top"
                        className="text-ellipsis d-inline-block wm-chart-card-title-campaign"
                      >
                        <span style={{ color: kpi_data?.[7]?.text_color }}>
                          {kpi_data?.[7]?.text?.length >= 40
                            ? `${kpi_data?.[7]?.text.substring(0, 40)}...`
                            : kpi_data?.[7]?.text}
                        </span>
                      </Tooltip>
                    </div>
                    <div
                      style={{
                        display: "block !important",
                        textAlign: "center",
                      }}
                    >
                      <Tooltip
                        placement="bottom"
                        title={
                          kpi_data?.[7]?.value
                            ? TooltipFormatter(kpi_data?.[7]?.value)
                            : ""
                        }
                        style={{ whiteSpace: "nowrap" }}
                      >
                        <span
                          className={`${
                            kpi_data?.[7]?.text_color !== "#000000"
                              ? "wm-chart-card-value-color"
                              : "wm-chart-card-value"
                          } mr-1 no--wrap`}
                          style={
                            kpi_data?.[7]?.text_color !== "#000000"
                              ? { color: kpi_data?.[7]?.text_color }
                              : {}
                          }
                        >
                          {kpi_data?.[7]?.value === null
                            ? "NA"
                            : kFormatter(kpi_data?.[7]?.value, true)}
                        </span>
                      </Tooltip>
                    </div>
                  </div>
                </div>
              </div>
            </>
          ) : (
            kpi_data?.map((data, i) => {
              count = count + 1;
              const pptStatus =
                ppt_generating_status &&
                (cardPosition === "Left" || cardPosition === "Right")
                  ? count <= 5
                  : (PdfDownloadStatus || ppt_generating_status) &&
                    type !== "kpi"
                  ? cardPosition &&
                    (cardPosition === "Left" || cardPosition === "Right")
                    ? noteExist
                      ? count <= 6
                      : count <= 8
                    : count <= 15
                  : count <= 15;

              const valueArray = isNaN(data?.value) && data?.value?.split(",");
              let channelImage =
                isString(data?.text) && data?.text?.includes("|$|")
                  ? data?.text?.split("|$|")?.[0]?.trim()
                  : null;
              let ProfileName =
                isString(data?.text) && data?.text?.includes("|$|")
                  ? data?.text?.split("|$|")?.[1]?.trim()
                  : null;
              let profile_filter_flag = data?.[0]?.text?.includes("|$|");
              let genderName =
                isString(data?.text) && data?.text?.includes("|G|")
                  ? data?.text?.split("|G|")?.[1]?.trim()
                  : null;
              let countryName =
                isString(data?.text) && data?.text?.includes("|C|")
                  ? data?.text?.split("|C|")?.[1]?.trim()
                  : null;
              if (pptStatus)
                if (Array.isArray(data) && profile_filter_flag) {
                  let channelImage1 = data?.[0]?.text
                    ?.split("|$|")?.[0]
                    ?.trim();
                  let ProfileName1 = data?.[0]?.text?.split("|$|")?.[1]?.trim();
                  let genderName1 = data?.[0]?.text?.split("|G|")?.[1]?.trim();
                  let countryName1 = data?.[0]?.text?.split("|C|")?.[1]?.trim();
                  let flrValue =
                    (data?.isFlrFormatted ||
                      graphConditionConfig?.[
                        "ticket-time-label-attrs"
                      ]?.includes(data?.y_series?.attribute)) &&
                    data?.value &&
                    data?.value?.toString()?.includes(" | ") &&
                    data?.value?.toString()?.split(" | ");
                  return (
                    <>
                      <div
                        key={`${data?.value}_${i}`}
                        className={`portlet1 border-radius-16 ${
                          ppt_generating_status ? "border" : ""
                        } ${
                          PdfDownloadStatus || ppt_generating_status
                            ? cardPosition === "Left"
                              ? " p-5"
                              : cardPosition === "Right"
                              ? " p-5"
                              : " p-5"
                            : cardPosition === "Left"
                            ? " p-3"
                            : cardPosition === "Right"
                            ? " p-3"
                            : " pt-4 pb-4"
                        } text-center ${
                          (cardPosition && cardPosition === "Left") ||
                          cardPosition === "Right"
                            ? "wm-chart-cards-left w-100"
                            : ""
                        }`}
                        style={
                          data?.[0]?.color &&
                          data?.[0]?.color?.trim() != "#000000"
                            ? {
                                border: data?.[0]?.border_color
                                  ? `3px solid ${data?.[0]?.border_color}66`
                                  : "3px solid var(--locobuzz-border-color)",
                                boxShadow:
                                  "0 0 0.6rem " +
                                  data?.[0]?.color?.trim() +
                                  "10",
                                //border: "0.1rem solid " + data?.[0]?.color?.trim() + "80",
                                backgroundColor:
                                  data?.[0]?.color?.trim() + "30",
                                color: "#",
                                cursor:
                                  data?.attribute &&
                                  deepdiveTypes?.includes(data?.attribute)
                                    ? "pointer"
                                    : null,
                                flex:
                                  cardPosition === "Left" ||
                                  cardPosition === "Right" ||
                                  (ppt_generating_status &&
                                    type !== "kpi" &&
                                    widget_metadata?.span !== "one_third" &&
                                    widget_metadata?.span !== "half" &&
                                    kpi_data?.length <= 4)
                                    ? ""
                                    : widget_metadata?.span === "half" &&
                                      !PdfDownloadStatus
                                    ? "1 0 calc(50% - 2.4rem)"
                                    : widget_metadata?.span === "one_third" &&
                                      !PdfDownloadStatus
                                    ? "1 0 calc(100% - 1.5rem)"
                                    : PdfDownloadStatus || ppt_generating_status
                                    ? "1 0 calc(20% - 1.5rem)"
                                    : "1 0 calc(25% - 1.5rem)",
                                width:
                                  cardPosition === "Left" ||
                                  cardPosition === "Right"
                                    ? ""
                                    : ppt_generating_status &&
                                      type !== "kpi" &&
                                      widget_metadata?.span !== "one_third" &&
                                      widget_metadata?.span !== "half" &&
                                      kpi_data?.length <= 4
                                    ? kpi_data?.length === 1
                                      ? "100%"
                                      : kpi_data?.length === 2
                                      ? "50%"
                                      : kpi_data?.length === 3
                                      ? "33.3%"
                                      : kpi_data?.length === 4
                                      ? "25%"
                                      : ""
                                    : "",
                              }
                            : {
                                border:
                                  "3px solid var(--locobuzz-border-color)",
                                boxShadow: "0 0 0.6rem #c3cbd710",
                                // border:
                                //   authParams?.theme_type === "1"
                                //     ? ""
                                //     : "0.1rem solid #c3cbd7",
                                cursor:
                                  (data?.attribute &&
                                    deepdiveTypes?.includes(data?.attribute)) ||
                                  (KPIdive &&
                                    data?.value !== 0 &&
                                    !/^0\/\d+$/.test(data.value))
                                    ? "pointer"
                                    : null,
                                flex:
                                  cardPosition === "Left" ||
                                  cardPosition === "Right" ||
                                  (ppt_generating_status &&
                                    type !== "kpi" &&
                                    widget_metadata?.span !== "one_third" &&
                                    widget_metadata?.span !== "half" &&
                                    kpi_data?.length <= 4)
                                    ? ""
                                    : widget_metadata?.span === "half" &&
                                      !PdfDownloadStatus
                                    ? "1 0 calc(50% - 2.4rem)"
                                    : widget_metadata?.span === "one_third" &&
                                      !PdfDownloadStatus
                                    ? "1 0 calc(100% - 1.5rem)"
                                    : PdfDownloadStatus || ppt_generating_status
                                    ? "1 0 calc(20% - 1.5rem)"
                                    : "1 0 calc(25% - 1.5rem)",
                                width:
                                  cardPosition === "Left" ||
                                  cardPosition === "Right"
                                    ? ""
                                    : ppt_generating_status &&
                                      type !== "kpi" &&
                                      widget_metadata?.span !== "one_third" &&
                                      widget_metadata?.span !== "half" &&
                                      kpi_data?.length <= 4
                                    ? kpi_data?.length === 1
                                      ? "100%"
                                      : kpi_data?.length === 2
                                      ? "50%"
                                      : kpi_data?.length === 3
                                      ? "33.3%"
                                      : kpi_data?.length === 4
                                      ? "25%"
                                      : ""
                                    : "",
                              }
                        }
                        onClick={(e) =>
                          ((data?.attribute &&
                            deepdiveTypes?.includes(data?.attribute) &&
                            ((!shareBrands &&
                              panes[getPaneIndex(panes, activeKey)]
                                ?.predefined &&
                              panes[getPaneIndex(panes, activeKey)]
                                ?.template_type !== "ticket") ||
                              (!shareBrands &&
                                !panes[getPaneIndex(panes, activeKey)]
                                  ?.predefined &&
                                panes[getPaneIndex(panes, activeKey)]
                                  .isDashboard) ||
                              shareableLinkDeepDiveStatus ||
                              (!shareBrands
                                ? isDeepDiveDashboardView
                                : shareableLinkDeepDiveStatus &&
                                  isDeepDiveDashboardView)) &&
                            (window?.location?.pathname === "/dashboard" ||
                              window.location.pathname === "/pin-dashboard" ||
                              shareableLinkDeepDiveStatus ||
                              (!shareBrands
                                ? isDeepDiveDashboardView
                                : shareableLinkDeepDiveStatus &&
                                  isDeepDiveDashboardView)) &&
                            isDeepDive) ||
                            (KPIdive &&
                              data?.value !== 0 &&
                              !/^0\/\d+$/.test(data.value) &&
                              (window?.location?.pathname === "/dashboard" ||
                                window.location.pathname === "/pin-dashboard" ||
                                shareableLinkDeepDiveStatus ||
                                (!shareBrands
                                  ? isDeepDiveDashboardView
                                  : shareableLinkDeepDiveStatus &&
                                    isDeepDiveDashboardView)) &&
                              isDeepDive)) &&
                          handleKpiDeepdive(e, data)
                        }
                      >
                        <Tooltip
                          title={
                            data?.[0]?.text &&
                            data?.[0]?.text?.includes("|$|") ? (
                              <>
                                <img
                                  style={{
                                    width: "1.5rem",
                                    height: "1.5rem",
                                    marginRight: "0.5rem",
                                  }}
                                  src={
                                    channelImage1
                                      ? SocialMedialogo?.[channelImage1]
                                      : defaultImage
                                  }
                                />
                                {ProfileName1}
                              </>
                            ) : data?.[0]?.text &&
                              data?.[0]?.text?.includes("|G|") ? (
                              <>
                                <img
                                  style={{
                                    width: "1.5rem",
                                    height: "1.5rem",
                                    marginRight: "0.5rem",
                                  }}
                                  src={getGenderLogo(genderName1)}
                                />
                                {genderName1}
                              </>
                            ) : data?.[0]?.text &&
                              data?.[0]?.text?.includes("|C|") ? (
                              <>
                                {getCountryLogo(countryName1)}
                                {countryName1}
                              </>
                            ) : (
                              ""
                            )
                          }
                        >
                          <span
                            className={`${
                              ppt_generating_status
                                ? "d-block"
                                : "d-inline-block"
                            } text-ellipsis wm-chart-card-title`}
                            style={{
                              width: ppt_generating_status ? "100%" : "",
                            }}
                          >
                            {data?.[0]?.text &&
                            data?.[0]?.text?.includes("|$|") ? (
                              <>
                                <img
                                  style={{
                                    width: "1.5rem",
                                    height: "1.5rem",
                                    marginRight: "0.5rem",
                                  }}
                                  src={
                                    channelImage1
                                      ? SocialMedialogo?.[channelImage1]
                                      : defaultImage
                                  }
                                />
                                {ProfileName1}
                              </>
                            ) : data?.[0]?.text &&
                              data?.[0]?.text?.includes("|G|") ? (
                              <>
                                <img
                                  style={{
                                    width: "1.5rem",
                                    height: "1.5rem",
                                    marginRight: "0.5rem",
                                  }}
                                  src={getGenderLogo(genderName1)}
                                />
                                {genderName1}
                              </>
                            ) : data?.[0]?.text &&
                              data?.[0]?.text?.includes("|C|") ? (
                              <>
                                {getCountryLogo(countryName1)}
                                {countryName1}
                              </>
                            ) : (
                              ""
                            )}
                          </span>
                        </Tooltip>
                        <div className="row m-0">
                          <div className="col-12 col-md-6 border-right border-color px-5px">
                            {widgetShareOfData && data?.share ? (
                              <>
                                <div className="d-flex align-items-baseline justify-content-center">
                                  <Tooltip
                                    placement="bottom"
                                    title={
                                      data?.value &&
                                      (data?.isFlrFormatted ||
                                        graphConditionConfig?.[
                                          "ticket-time-label-attrs"
                                        ]?.includes(data?.y_series?.attribute))
                                        ? data?.value
                                            ?.toString()
                                            ?.includes(" | ")
                                          ? SecondstoHumanReadable(
                                              flrValue?.[0],
                                              true
                                            ) +
                                            " | " +
                                            flrValue?.[1]
                                          : SecondstoHumanReadable(
                                              data?.value,
                                              true
                                            )
                                        : data?.value
                                        ? TooltipFormatter(data?.value)
                                        : ""
                                    }
                                  >
                                    <span
                                      className={`${
                                        data?.text_color &&
                                        data?.text_color !== "#000000"
                                          ? "wm-chart-card-value-color"
                                          : "wm-chart-card-value"
                                      } mr-1 no--wrap`}
                                      style={
                                        data?.text_color &&
                                        data?.text_color !== "#000000"
                                          ? { color: data?.text_color }
                                          : {}
                                      }
                                    >
                                      {data?.value === null
                                        ? "NA"
                                        : data?.value &&
                                          (data?.isFlrFormatted ||
                                            graphConditionConfig?.[
                                              "ticket-time-label-attrs"
                                            ]?.includes(
                                              data?.y_series?.attribute
                                            ))
                                        ? data?.value
                                            ?.toString()
                                            ?.includes(" | ")
                                          ? SecondstoHumanReadable(
                                              flrValue?.[0],
                                              true
                                            ) +
                                            " | " +
                                            flrValue?.[1]
                                          : SecondstoHumanReadable(
                                              data?.value,
                                              true
                                            )
                                        : graphConditionConfig?.round_kpi_attrs?.includes(
                                            data?.attribute
                                          )
                                        ? isNaN(data?.value) &&
                                          valueArray?.length > 1
                                          ? valueArray[0] + " " + valueArray[1]
                                          : kFormatter(data?.value, false, true)
                                        : isNaN(data?.value) &&
                                          valueArray?.length > 1
                                        ? valueArray[0] + " " + valueArray[1]
                                        : kFormatter(data?.value, true)}
                                    </span>
                                  </Tooltip>
                                  {data?.share ? (
                                    <span className="d-flex align-items-center font-size12 font-weight600 text-blue cursor-default ml-1 no--wrap">
                                      {/* <img
                                          src={ShareIcon}
                                          style={{ maxWidth: "1.5rem" }}
                                          className="mr-1"
                                        /> */}
                                      <span
                                        className="pie__of--share mr-1"
                                        style={{
                                          border: "0.2rem solid " + "#185EDF",
                                          backgroundImage:
                                            "conic-gradient(" +
                                            "#185EDF " +
                                            data?.share * 3.6 +
                                            "deg,#ffff " +
                                            data?.share * 3.6 +
                                            "deg)",
                                        }}
                                      ></span>
                                      <span>{data?.share} %</span>
                                    </span>
                                  ) : (
                                    <span className="text_regular font-size12 font-weight600 text-gray"></span>
                                  )}
                                </div>
                                <div>
                                  {widgetDurationComparison &&
                                  data?.percent_change !== null ? (
                                    <span
                                      className={`text_regular justify-content-center ${
                                        data?.percent_change === 0
                                          ? "d-flex"
                                          : "d-flex"
                                      } align-items-baseline ${
                                        String(data?.text).toLowerCase() ===
                                        String("Negative").toLowerCase()
                                          ? data?.percent_change > 0
                                            ? "negative"
                                            : data?.percent_change < 0
                                            ? "positive"
                                            : "text-gray"
                                          : data?.percent_change > 0
                                          ? "positive"
                                          : data?.percent_change < 0
                                          ? "negative"
                                          : "text-gray"
                                      } font-size12`}
                                    >
                                      {data?.percent_change === null ? (
                                        ""
                                      ) : data?.percent_change > 0 ? (
                                        <>
                                          <CaretUpFilled className="font-size18" />
                                          {" " +
                                            Number(
                                              data?.percent_change
                                            )?.toLocaleString() +
                                            "%"}
                                        </>
                                      ) : data?.percent_change < 0 ? (
                                        <>
                                          <CaretDownFilled className="font-size18" />
                                          {" " +
                                            Number(
                                              data?.percent_change
                                            )?.toLocaleString() +
                                            "%"}
                                        </>
                                      ) : (
                                        data?.percent_change !== null && "NA"
                                      )}{" "}
                                    </span>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              </>
                            ) : (
                              <div className="d-flex align-items-baseline justify-content-center">
                                <span
                                  className={`${
                                    data?.[0]?.text_color &&
                                    data?.[0]?.text_color !== "#000000"
                                      ? "wm-chart-card-value-color"
                                      : "wm-chart-card-value"
                                  } mr-1`}
                                  style={
                                    data?.[0]?.text_color &&
                                    data?.[0]?.text_color !== "#000000"
                                      ? { color: data?.[0]?.text_color }
                                      : {}
                                  }
                                >
                                  <Tooltip
                                    placement="bottom"
                                    className="d-flex"
                                    title={
                                      data?.[0]?.value
                                        ? TooltipFormatter(data?.[0]?.value)
                                        : ""
                                    }
                                    style={{
                                      whiteSpace: "nowrap",
                                    }}
                                  >
                                    {data?.[0]?.value === null
                                      ? "NA"
                                      : graphConditionConfig?.round_kpi_attrs?.includes(
                                          data?.[0]?.attribute
                                        )
                                      ? isNaN(data?.[0]?.value) &&
                                        valueArray?.length > 1
                                        ? valueArray[0] + " " + valueArray[1]
                                        : kFormatter(
                                            data?.[0]?.value,
                                            false,
                                            true
                                          )
                                      : isNaN(data?.[0]?.value) &&
                                        valueArray?.length > 1
                                      ? valueArray[0] + " " + valueArray[1]
                                      : kFormatter(data?.[0]?.value, true)}
                                  </Tooltip>
                                </span>

                                {widgetDurationComparison &&
                                data?.percent_change !== null ? (
                                  <span
                                    className={`text_regular ${
                                      data?.percent_change === 0
                                        ? "d-flex"
                                        : "d-flex"
                                    } align-items-baseline ${
                                      String(data?.text).toLowerCase() ===
                                      String("Negative").toLowerCase()
                                        ? data?.percent_change > 0
                                          ? "negative"
                                          : data?.percent_change < 0
                                          ? "positive"
                                          : "text-gray"
                                        : data?.percent_change > 0
                                        ? "positive"
                                        : data?.percent_change < 0
                                        ? "negative"
                                        : "text-gray"
                                    } font-size12`}
                                  >
                                    {data?.percent_change === null ? (
                                      ""
                                    ) : data?.percent_change > 0 ? (
                                      <>
                                        <CaretUpFilled className="font-size18" />
                                        {" " +
                                          Number(
                                            data?.percent_change
                                          )?.toLocaleString() +
                                          "%"}
                                      </>
                                    ) : data?.percent_change < 0 ? (
                                      <>
                                        <CaretDownFilled className="font-size18" />
                                        {" " +
                                          Number(
                                            data?.percent_change
                                          )?.toLocaleString() +
                                          "%"}
                                      </>
                                    ) : (
                                      data?.percent_change !== null && "NA"
                                    )}{" "}
                                  </span>
                                ) : (
                                  ""
                                )}
                              </div>
                            )}
                            <div className="wm-chart-card-title line-height-normal">
                              <Tooltip
                                title={
                                  ["000-100-809"]?.includes(
                                    widget_metadata?.widget_id
                                  )
                                    ? "Total / New Followers"
                                    : data?.[0]?.base_name
                                    ? data?.[0]?.base_name
                                    : ""
                                }
                                placement="top"
                                className="text-ellipsis d-inline-block wm-chart-card-title"
                              >
                                {data?.[0]?.base_name}
                              </Tooltip>
                            </div>
                          </div>
                          <div className="col-12 col-md-6 px-5px">
                            <Tooltip
                              title={
                                data?.[1]?.base_name && (
                                  <>{data?.[1]?.base_name}</>
                                )
                              }
                              placement="top"
                              className="text-ellipsis d-inline-block wm-chart-card-title"
                            >
                              <div className="wm-chart-card-value">
                                {data?.[1]?.value}
                              </div>
                              <div className="text-ellipsis d-inline-block wm-chart-card-title line-height-normal">
                                {data?.[1]?.base_name && (
                                  <>{data?.[1]?.base_name}</>
                                )}
                              </div>
                            </Tooltip>
                          </div>
                        </div>
                      </div>
                    </>
                  );
                } else if (Array.isArray(data) && !profile_filter_flag) {
                  let flrValue =
                    (data?.isFlrFormatted ||
                      graphConditionConfig?.[
                        "ticket-time-label-attrs"
                      ]?.includes(data?.y_series?.attribute)) &&
                    data?.value &&
                    data?.value?.toString()?.includes(" | ") &&
                    data?.value?.toString()?.split(" | ");
                  return (
                    <>
                      <div
                        key={`${data?.value}_${i}`}
                        className={`portlet1 border-radius-16 ${
                          ppt_generating_status ? "border" : ""
                        } ${
                          PdfDownloadStatus || ppt_generating_status
                            ? cardPosition === "Left"
                              ? " p-5"
                              : cardPosition === "Right"
                              ? " p-5"
                              : " p-5"
                            : cardPosition === "Left"
                            ? " p-3"
                            : cardPosition === "Right"
                            ? " p-3"
                            : " pt-4 pb-4"
                        } text-center ${
                          (cardPosition && cardPosition === "Left") ||
                          cardPosition === "Right"
                            ? "wm-chart-cards-left w-100"
                            : ""
                        }`}
                        style={
                          data?.[0]?.color &&
                          data?.[0]?.color?.trim() != "#000000"
                            ? {
                                border: data?.[0]?.border_color
                                  ? `3px solid ${data?.[0]?.border_color}66`
                                  : "3px solid var(--locobuzz-border-color)",
                                boxShadow:
                                  "0 0 0.6rem " +
                                  data?.[0]?.color?.trim() +
                                  "10",
                                //border: "0.1rem solid " + data?.[0]?.color?.trim() + "80",
                                backgroundColor:
                                  data?.[0]?.color?.trim() + "30",
                                color: "#",
                                cursor:
                                  data?.attribute &&
                                  deepdiveTypes?.includes(data?.attribute)
                                    ? "pointer"
                                    : null,
                                flex:
                                  cardPosition === "Left" ||
                                  cardPosition === "Right" ||
                                  (ppt_generating_status &&
                                    type !== "kpi" &&
                                    widget_metadata?.span !== "one_third" &&
                                    widget_metadata?.span !== "half" &&
                                    kpi_data?.length <= 4)
                                    ? ""
                                    : widget_metadata?.span === "half" &&
                                      !PdfDownloadStatus
                                    ? "1 0 calc(50% - 2.4rem)"
                                    : widget_metadata?.span === "one_third" &&
                                      !PdfDownloadStatus
                                    ? "1 0 calc(100% - 1.5rem)"
                                    : PdfDownloadStatus || ppt_generating_status
                                    ? "1 0 calc(20% - 1.5rem)"
                                    : "1 0 calc(25% - 1.5rem)",
                                width:
                                  cardPosition === "Left" ||
                                  cardPosition === "Right"
                                    ? ""
                                    : ppt_generating_status &&
                                      type !== "kpi" &&
                                      widget_metadata?.span !== "one_third" &&
                                      widget_metadata?.span !== "half" &&
                                      kpi_data?.length <= 4
                                    ? kpi_data?.length === 1
                                      ? "100%"
                                      : kpi_data?.length === 2
                                      ? "50%"
                                      : kpi_data?.length === 3
                                      ? "33.3%"
                                      : kpi_data?.length === 4
                                      ? "25%"
                                      : ""
                                    : "",
                              }
                            : {
                                border:
                                  "3px solid var(--locobuzz-border-color)",
                                boxShadow: "0 0 0.6rem #c3cbd710",
                                // border:
                                //   authParams?.theme_type === "1"
                                //     ? ""
                                //     : "0.1rem solid #c3cbd7",
                                cursor:
                                  (data?.attribute &&
                                    deepdiveTypes?.includes(data?.attribute)) ||
                                  (KPIdive &&
                                    data?.value !== 0 &&
                                    !/^0\/\d+$/.test(data.value))
                                    ? "pointer"
                                    : null,
                                flex:
                                  cardPosition === "Left" ||
                                  cardPosition === "Right" ||
                                  (ppt_generating_status &&
                                    type !== "kpi" &&
                                    widget_metadata?.span !== "one_third" &&
                                    widget_metadata?.span !== "half" &&
                                    kpi_data?.length <= 4)
                                    ? ""
                                    : widget_metadata?.span === "half" &&
                                      !PdfDownloadStatus
                                    ? "1 0 calc(50% - 2.4rem)"
                                    : widget_metadata?.span === "one_third" &&
                                      !PdfDownloadStatus
                                    ? "1 0 calc(100% - 1.5rem)"
                                    : PdfDownloadStatus || ppt_generating_status
                                    ? "1 0 calc(20% - 1.5rem)"
                                    : "1 0 calc(25% - 1.5rem)",
                                width:
                                  cardPosition === "Left" ||
                                  cardPosition === "Right"
                                    ? ""
                                    : ppt_generating_status &&
                                      type !== "kpi" &&
                                      widget_metadata?.span !== "one_third" &&
                                      widget_metadata?.span !== "half" &&
                                      kpi_data?.length <= 4
                                    ? kpi_data?.length === 1
                                      ? "100%"
                                      : kpi_data?.length === 2
                                      ? "50%"
                                      : kpi_data?.length === 3
                                      ? "33.3%"
                                      : kpi_data?.length === 4
                                      ? "25%"
                                      : ""
                                    : "",
                              }
                        }
                        onClick={(e) =>
                          ((data?.attribute &&
                            deepdiveTypes?.includes(data?.attribute) &&
                            ((!shareBrands &&
                              panes[getPaneIndex(panes, activeKey)]
                                ?.predefined &&
                              panes[getPaneIndex(panes, activeKey)]
                                ?.template_type !== "ticket") ||
                              (!shareBrands &&
                                !panes[getPaneIndex(panes, activeKey)]
                                  ?.predefined &&
                                panes[getPaneIndex(panes, activeKey)]
                                  .isDashboard) ||
                              shareableLinkDeepDiveStatus ||
                              (!shareBrands
                                ? isDeepDiveDashboardView
                                : shareableLinkDeepDiveStatus &&
                                  isDeepDiveDashboardView)) &&
                            (window?.location?.pathname === "/dashboard" ||
                              window.location.pathname === "/pin-dashboard" ||
                              shareableLinkDeepDiveStatus ||
                              (!shareBrands
                                ? isDeepDiveDashboardView
                                : shareableLinkDeepDiveStatus &&
                                  isDeepDiveDashboardView)) &&
                            isDeepDive) ||
                            (KPIdive &&
                              data?.value !== 0 &&
                              !/^0\/\d+$/.test(data.value) &&
                              (window?.location?.pathname === "/dashboard" ||
                                window.location.pathname === "/pin-dashboard" ||
                                shareableLinkDeepDiveStatus ||
                                (!shareBrands
                                  ? isDeepDiveDashboardView
                                  : shareableLinkDeepDiveStatus &&
                                    isDeepDiveDashboardView)) &&
                              isDeepDive)) &&
                          handleKpiDeepdive(e, data)
                        }
                      >
                        <Tooltip title={data?.[0]?.text}>
                          <span
                            className={`${
                              ppt_generating_status
                                ? "d-block"
                                : "d-inline-block"
                            } text-ellipsis wm-chart-card-title`}
                            style={{
                              width: ppt_generating_status ? "100%" : "",
                            }}
                          >
                            {data?.[0]?.text}
                          </span>
                        </Tooltip>
                        <div className="row m-0">
                          <div className="col-12 col-md-6 border-right border-color px-5px">
                            {widgetShareOfData && data?.[0]?.share ? (
                              <>
                                <div className="d-flex align-items-baseline justify-content-center">
                                  <Tooltip
                                    placement="bottom"
                                    title={
                                      data?.[0]?.value &&
                                      (data?.isFlrFormatted ||
                                        graphConditionConfig?.[
                                          "ticket-time-label-attrs"
                                        ]?.includes(data?.y_series?.attribute))
                                        ? data?.[0]?.value
                                            ?.toString()
                                            ?.includes(" | ")
                                          ? SecondstoHumanReadable(
                                              flrValue?.[0],
                                              true
                                            ) +
                                            " | " +
                                            flrValue?.[1]
                                          : SecondstoHumanReadable(
                                              data?.[0]?.value,
                                              true
                                            )
                                        : data?.[0]?.value
                                        ? TooltipFormatter(data?.[0]?.value)
                                        : ""
                                    }
                                  >
                                    <span
                                      className={`${
                                        data?.[0]?.text_color &&
                                        data?.[0]?.text_color !== "#000000"
                                          ? "wm-chart-card-value-color"
                                          : "wm-chart-card-value"
                                      } mr-1 no--wrap`}
                                      style={
                                        data?.[0]?.text_color &&
                                        data?.[0]?.text_color !== "#000000"
                                          ? { color: data?.[0]?.text_color }
                                          : {}
                                      }
                                    >
                                      {data?.[0]?.value === null
                                        ? "NA"
                                        : data?.[0]?.value &&
                                          (data?.isFlrFormatted ||
                                            graphConditionConfig?.[
                                              "ticket-time-label-attrs"
                                            ]?.includes(
                                              data?.y_series?.attribute
                                            ))
                                        ? data?.[0]?.value
                                            ?.toString()
                                            ?.includes(" | ")
                                          ? SecondstoHumanReadable(
                                              flrValue?.[0],
                                              true
                                            ) +
                                            " | " +
                                            flrValue?.[1]
                                          : SecondstoHumanReadable(
                                              data?.[0]?.value,
                                              true
                                            )
                                        : graphConditionConfig?.round_kpi_attrs?.includes(
                                            data?.attribute
                                          )
                                        ? isNaN(data?.[0]?.value) &&
                                          valueArray?.length > 1
                                          ? valueArray[0] + " " + valueArray[1]
                                          : kFormatter(
                                              data?.[0]?.value,
                                              false,
                                              true
                                            )
                                        : isNaN(data?.[0]?.value) &&
                                          valueArray?.length > 1
                                        ? valueArray[0] + " " + valueArray[1]
                                        : kFormatter(data?.[0]?.value, true)}
                                    </span>
                                  </Tooltip>
                                  {data?.[0]?.share ? (
                                    <span className="d-flex align-items-center font-size12 font-weight600 text-blue cursor-default ml-1 no--wrap">
                                      <span
                                        className="pie__of--share mr-1"
                                        style={{
                                          border: "0.2rem solid " + "#185EDF",
                                          backgroundImage:
                                            "conic-gradient(" +
                                            "#185EDF " +
                                            data?.[0]?.share * 3.6 +
                                            "deg,#ffff " +
                                            data?.[0]?.share * 3.6 +
                                            "deg)",
                                        }}
                                      ></span>
                                      <span>{data?.[0]?.share} %</span>
                                    </span>
                                  ) : (
                                    <span className="text_regular font-size12 font-weight600 text-gray"></span>
                                  )}
                                </div>
                              </>
                            ) : (
                              <div className="d-flex align-items-baseline justify-content-center">
                                <span
                                  className={`${
                                    data?.[0]?.text_color &&
                                    data?.[0]?.text_color !== "#000000"
                                      ? "wm-chart-card-value-color"
                                      : "wm-chart-card-value"
                                  } mr-1`}
                                  style={
                                    data?.[0]?.text_color &&
                                    data?.[0]?.text_color !== "#000000"
                                      ? { color: data?.[0]?.text_color }
                                      : {}
                                  }
                                >
                                  <Tooltip
                                    placement="bottom"
                                    className="d-flex"
                                    title={
                                      data?.[0]?.value
                                        ? TooltipFormatter(data?.[0]?.value)
                                        : ""
                                    }
                                    style={{
                                      whiteSpace: "nowrap",
                                    }}
                                  >
                                    {data?.[0]?.value === null
                                      ? "NA"
                                      : graphConditionConfig?.round_kpi_attrs?.includes(
                                          data?.[0]?.attribute
                                        )
                                      ? isNaN(data?.[0]?.value) &&
                                        valueArray?.length > 1
                                        ? valueArray[0] + " " + valueArray[1]
                                        : kFormatter(
                                            data?.[0]?.value,
                                            false,
                                            true
                                          )
                                      : isNaN(data?.[0]?.value) &&
                                        valueArray?.length > 1
                                      ? valueArray[0] + " " + valueArray[1]
                                      : kFormatter(data?.[0]?.value, true)}
                                  </Tooltip>
                                </span>

                                {widgetDurationComparison &&
                                data?.percent_change !== null ? (
                                  <span
                                    className={`text_regular ${
                                      data?.percent_change === 0
                                        ? "d-flex"
                                        : "d-flex"
                                    } align-items-baseline ${
                                      String(data?.text).toLowerCase() ===
                                      String("Negative").toLowerCase()
                                        ? data?.percent_change > 0
                                          ? "negative"
                                          : data?.percent_change < 0
                                          ? "positive"
                                          : "text-gray"
                                        : data?.percent_change > 0
                                        ? "positive"
                                        : data?.percent_change < 0
                                        ? "negative"
                                        : "text-gray"
                                    } font-size12`}
                                  >
                                    {data?.percent_change === null ? (
                                      ""
                                    ) : data?.percent_change > 0 ? (
                                      <>
                                        <CaretUpFilled className="font-size18" />
                                        {" " +
                                          Number(
                                            data?.percent_change
                                          )?.toLocaleString() +
                                          "%"}
                                      </>
                                    ) : data?.percent_change < 0 ? (
                                      <>
                                        <CaretDownFilled className="font-size18" />
                                        {" " +
                                          Number(
                                            data?.percent_change
                                          )?.toLocaleString() +
                                          "%"}
                                      </>
                                    ) : (
                                      data?.percent_change !== null && "NA"
                                    )}{" "}
                                  </span>
                                ) : (
                                  ""
                                )}
                              </div>
                            )}
                            <div className="wm-chart-card-title line-height-normal">
                              <Tooltip
                                title={
                                  ["000-100-809"]?.includes(
                                    widget_metadata?.widget_id
                                  )
                                    ? "Total / New Followers"
                                    : data?.[0]?.base_name
                                    ? data?.[0]?.base_name
                                    : ""
                                }
                                placement="top"
                                className="text-ellipsis d-inline-block wm-chart-card-title"
                              >
                                {data?.[0]?.base_name}
                              </Tooltip>
                            </div>
                          </div>
                          <div className="col-12 col-md-6 px-5px">
                            {widgetShareOfData && data?.[1]?.share ? (
                              <>
                                <div className="d-flex align-items-baseline justify-content-center">
                                  <Tooltip
                                    placement="bottom"
                                    title={
                                      data?.[1]?.value &&
                                      (data?.isFlrFormatted ||
                                        graphConditionConfig?.[
                                          "ticket-time-label-attrs"
                                        ]?.includes(data?.y_series?.attribute))
                                        ? data?.[1]?.value
                                            ?.toString()
                                            ?.includes(" | ")
                                          ? SecondstoHumanReadable(
                                              flrValue?.[0],
                                              true
                                            ) +
                                            " | " +
                                            flrValue?.[1]
                                          : SecondstoHumanReadable(
                                              data?.[1]?.value,
                                              true
                                            )
                                        : data?.[1]?.value
                                        ? TooltipFormatter(data?.[1]?.value)
                                        : ""
                                    }
                                  >
                                    <span
                                      className={`wm-chart-card-value mr-1 no--wrap`}
                                    >
                                      {data?.[1]?.value === null
                                        ? "NA"
                                        : data?.[1]?.value &&
                                          (data?.isFlrFormatted ||
                                            graphConditionConfig?.[
                                              "ticket-time-label-attrs"
                                            ]?.includes(
                                              data?.y_series?.attribute
                                            ))
                                        ? data?.[1]?.value
                                            ?.toString()
                                            ?.includes(" | ")
                                          ? SecondstoHumanReadable(
                                              flrValue?.[0],
                                              true
                                            ) +
                                            " | " +
                                            flrValue?.[1]
                                          : SecondstoHumanReadable(
                                              data?.[1]?.value,
                                              true
                                            )
                                        : graphConditionConfig?.round_kpi_attrs?.includes(
                                            data?.attribute
                                          )
                                        ? isNaN(data?.[1]?.value) &&
                                          valueArray?.length > 1
                                          ? valueArray[0] + " " + valueArray[1]
                                          : kFormatter(
                                              data?.[1]?.value,
                                              false,
                                              true
                                            )
                                        : isNaN(data?.[1]?.value) &&
                                          valueArray?.length > 1
                                        ? valueArray[0] + " " + valueArray[1]
                                        : kFormatter(data?.[1]?.value, true)}
                                    </span>
                                  </Tooltip>
                                  {data?.[1]?.share ? (
                                    <span className="d-flex align-items-center font-size12 font-weight600 text-blue cursor-default ml-1 no--wrap">
                                      <span
                                        className="pie__of--share mr-1"
                                        style={{
                                          border: "0.2rem solid " + "#185EDF",
                                          backgroundImage:
                                            "conic-gradient(" +
                                            "#185EDF " +
                                            data?.[1]?.share * 3.6 +
                                            "deg,#ffff " +
                                            data?.[1]?.share * 3.6 +
                                            "deg)",
                                        }}
                                      ></span>
                                      <span>{data?.[1]?.share} %</span>
                                    </span>
                                  ) : (
                                    <span className="text_regular font-size12 font-weight600 text-gray"></span>
                                  )}
                                </div>
                              </>
                            ) : (
                              <div className="d-flex align-items-baseline justify-content-center">
                                <span
                                  className={`${
                                    data?.[0]?.text_color &&
                                    data?.[0]?.text_color !== "#000000"
                                      ? "wm-chart-card-value-color"
                                      : "wm-chart-card-value"
                                  } mr-1`}
                                  style={
                                    data?.[0]?.text_color &&
                                    data?.[0]?.text_color !== "#000000"
                                      ? { color: data?.[0]?.text_color }
                                      : {}
                                  }
                                >
                                  <Tooltip
                                    placement="bottom"
                                    className="d-flex"
                                    title={
                                      data?.[1]?.value
                                        ? TooltipFormatter(data?.[1]?.value)
                                        : ""
                                    }
                                    style={{
                                      whiteSpace: "nowrap",
                                    }}
                                  >
                                    {data?.[1]?.value === null
                                      ? "NA"
                                      : graphConditionConfig?.round_kpi_attrs?.includes(
                                          data?.[1]?.attribute
                                        )
                                      ? isNaN(data?.[1]?.value) &&
                                        valueArray?.length > 1
                                        ? valueArray[0] + " " + valueArray[1]
                                        : kFormatter(
                                            data?.[1]?.value,
                                            false,
                                            true
                                          )
                                      : isNaN(data?.[1]?.value) &&
                                        valueArray?.length > 1
                                      ? valueArray[0] + " " + valueArray[1]
                                      : kFormatter(data?.[1]?.value, true)}
                                  </Tooltip>
                                </span>

                                {widgetDurationComparison &&
                                data?.percent_change !== null ? (
                                  <span
                                    className={`text_regular ${
                                      data?.percent_change === 0
                                        ? "d-flex"
                                        : "d-flex"
                                    } align-items-baseline ${
                                      String(data?.text).toLowerCase() ===
                                      String("Negative").toLowerCase()
                                        ? data?.percent_change > 0
                                          ? "negative"
                                          : data?.percent_change < 0
                                          ? "positive"
                                          : "text-gray"
                                        : data?.percent_change > 0
                                        ? "positive"
                                        : data?.percent_change < 0
                                        ? "negative"
                                        : "text-gray"
                                    } font-size12`}
                                  >
                                    {data?.percent_change === null ? (
                                      ""
                                    ) : data?.percent_change > 0 ? (
                                      <>
                                        <CaretUpFilled className="font-size18" />
                                        {" " +
                                          Number(
                                            data?.percent_change
                                          )?.toLocaleString() +
                                          "%"}
                                      </>
                                    ) : data?.percent_change < 0 ? (
                                      <>
                                        <CaretDownFilled className="font-size18" />
                                        {" " +
                                          Number(
                                            data?.percent_change
                                          )?.toLocaleString() +
                                          "%"}
                                      </>
                                    ) : (
                                      data?.percent_change !== null && "NA"
                                    )}{" "}
                                  </span>
                                ) : (
                                  ""
                                )}
                              </div>
                            )}
                            <Tooltip
                              title={
                                data?.[1]?.base_name && (
                                  <>{data?.[1]?.base_name}</>
                                )
                              }
                              placement="top"
                              className="text-ellipsis d-inline-block wm-chart-card-title"
                            >
                              <div className="text-ellipsis d-inline-block wm-chart-card-title line-height-normal">
                                {data?.[1]?.base_name && (
                                  <>{data?.[1]?.base_name}</>
                                )}
                              </div>
                            </Tooltip>
                          </div>
                        </div>
                      </div>
                    </>
                  );
                } else {
                  let flrValue =
                    (data?.isFlrFormatted ||
                      graphConditionConfig?.[
                        "ticket-time-label-attrs"
                      ]?.includes(data?.y_series?.attribute)) &&
                    data?.value &&
                    data?.value?.toString()?.includes(" | ") &&
                    data?.value?.toString()?.split(" | ");
                  return (
                    <div
                      key={`${data?.value}_${i}`}
                      className={`portlet1 border-radius-16 ${
                        ppt_generating_status ? "border" : ""
                      } ${
                        PdfDownloadStatus || ppt_generating_status
                          ? cardPosition === "Left"
                            ? " p-5"
                            : cardPosition === "Right"
                            ? " p-5"
                            : " p-5"
                          : cardPosition === "Left"
                          ? " p-3"
                          : cardPosition === "Right"
                          ? " p-3"
                          : " pt-4 pb-4"
                      } text-center ${
                        (cardPosition && cardPosition === "Left") ||
                        cardPosition === "Right"
                          ? "wm-chart-cards-left w-100"
                          : ""
                      }`}
                      style={
                        data?.color && data?.color?.trim() != "#000000"
                          ? {
                              border: data.border_color
                                ? `3px solid ${data.border_color}66`
                                : "3px solid var(--locobuzz-border-color)",
                              boxShadow:
                                "0 0 0.6rem " + data?.color?.trim() + "10",
                              //border: "0.1rem solid " + data?.color?.trim() + "80",
                              backgroundColor: data?.color?.trim() + "30",
                              color: "#",
                              cursor:
                                data?.attribute &&
                                deepdiveTypes?.includes(data?.attribute)
                                  ? "pointer"
                                  : null,
                              flex:
                                cardPosition === "Left" ||
                                cardPosition === "Right" ||
                                (ppt_generating_status &&
                                  type !== "kpi" &&
                                  widget_metadata?.span !== "one_third" &&
                                  widget_metadata?.span !== "half" &&
                                  kpi_data?.length <= 4)
                                  ? ""
                                  : widget_metadata?.span === "half" &&
                                    !PdfDownloadStatus
                                  ? "1 0 calc(50% - 2.4rem)"
                                  : widget_metadata?.span === "one_third" &&
                                    !PdfDownloadStatus
                                  ? "1 0 calc(100% - 1.5rem)"
                                  : PdfDownloadStatus || ppt_generating_status
                                  ? "1 0 calc(20% - 1.5rem)"
                                  : "1 0 calc(25% - 1.5rem)",
                              width:
                                cardPosition === "Left" ||
                                cardPosition === "Right"
                                  ? ""
                                  : ppt_generating_status &&
                                    type !== "kpi" &&
                                    widget_metadata?.span !== "one_third" &&
                                    widget_metadata?.span !== "half" &&
                                    kpi_data?.length <= 4
                                  ? kpi_data?.length === 1
                                    ? "100%"
                                    : kpi_data?.length === 2
                                    ? "50%"
                                    : kpi_data?.length === 3
                                    ? "33.3%"
                                    : kpi_data?.length === 4
                                    ? "25%"
                                    : ""
                                  : "",
                            }
                          : {
                              border: "3px solid var(--locobuzz-border-color)",
                              boxShadow: "0 0 0.6rem #c3cbd710",
                              // border:
                              //   authParams?.theme_type === "1"
                              //     ? ""
                              //     : "0.1rem solid #c3cbd7",
                              cursor:
                                (data?.attribute &&
                                  deepdiveTypes?.includes(data?.attribute)) ||
                                (KPIdive &&
                                  data?.value !== 0 &&
                                  !/^0\/\d+$/.test(data.value))
                                  ? "pointer"
                                  : null,
                              flex:
                                cardPosition === "Left" ||
                                cardPosition === "Right" ||
                                (ppt_generating_status &&
                                  type !== "kpi" &&
                                  widget_metadata?.span !== "one_third" &&
                                  widget_metadata?.span !== "half" &&
                                  kpi_data?.length <= 4)
                                  ? ""
                                  : widget_metadata?.span === "half" &&
                                    !PdfDownloadStatus
                                  ? "1 0 calc(50% - 2.4rem)"
                                  : widget_metadata?.span === "one_third" &&
                                    !PdfDownloadStatus
                                  ? "1 0 calc(100% - 1.5rem)"
                                  : PdfDownloadStatus || ppt_generating_status
                                  ? "1 0 calc(20% - 1.5rem)"
                                  : "1 0 calc(25% - 1.5rem)",
                              width:
                                cardPosition === "Left" ||
                                cardPosition === "Right"
                                  ? ""
                                  : ppt_generating_status &&
                                    type !== "kpi" &&
                                    widget_metadata?.span !== "one_third" &&
                                    widget_metadata?.span !== "half" &&
                                    kpi_data?.length <= 4
                                  ? kpi_data?.length === 1
                                    ? "100%"
                                    : kpi_data?.length === 2
                                    ? "50%"
                                    : kpi_data?.length === 3
                                    ? "33.3%"
                                    : kpi_data?.length === 4
                                    ? "25%"
                                    : ""
                                  : "",
                            }
                      }
                      onClick={(e) =>
                        ((data?.attribute &&
                          deepdiveTypes?.includes(data?.attribute) &&
                          ((!shareBrands &&
                            panes[getPaneIndex(panes, activeKey)]?.predefined &&
                            panes[getPaneIndex(panes, activeKey)]
                              ?.template_type !== "ticket") ||
                            (!shareBrands &&
                              !panes[getPaneIndex(panes, activeKey)]
                                ?.predefined &&
                              panes[getPaneIndex(panes, activeKey)]
                                .isDashboard) ||
                            shareableLinkDeepDiveStatus ||
                            (!shareBrands
                              ? isDeepDiveDashboardView
                              : shareableLinkDeepDiveStatus &&
                                isDeepDiveDashboardView)) &&
                          (window?.location?.pathname === "/dashboard" ||
                            window.location.pathname === "/pin-dashboard" ||
                            shareableLinkDeepDiveStatus ||
                            (!shareBrands
                              ? isDeepDiveDashboardView
                              : shareableLinkDeepDiveStatus &&
                                isDeepDiveDashboardView)) &&
                          isDeepDive) ||
                          (KPIdive &&
                            data?.value !== 0 &&
                            !/^0\/\d+$/.test(data.value) &&
                            (window?.location?.pathname === "/dashboard" ||
                              window.location.pathname === "/pin-dashboard" ||
                              shareableLinkDeepDiveStatus ||
                              (!shareBrands
                                ? isDeepDiveDashboardView
                                : shareableLinkDeepDiveStatus &&
                                  isDeepDiveDashboardView)) &&
                            isDeepDive)) &&
                        handleKpiDeepdive(e, data)
                      }
                    >
                      <div className="wm-chart-card-title mb-1 line-height-normal">
                        <Tooltip
                          title={
                            channelImage ? (
                              <>
                                <img
                                  style={{
                                    width: "1.5rem",
                                    height: "1.5rem",
                                    marginRight: "0.5rem",
                                  }}
                                  src={
                                    channelImage
                                      ? SocialMedialogo?.[channelImage]
                                      : defaultImage
                                  }
                                />
                                {ProfileName}
                              </>
                            ) : genderName ? (
                              <>
                                <img
                                  style={{
                                    width: "1.5rem",
                                    height: "1.5rem",
                                    marginRight: "0.5rem",
                                  }}
                                  src={getGenderLogo(genderName)}
                                />
                                {genderName}
                              </>
                            ) : countryName ? (
                              <>
                                {getCountryLogo(countryName)}
                                {countryName}
                              </>
                            ) : (
                              <>
                                {data?.attribute === "Rating"
                                  ? `${data?.text} ⭐`
                                  : data?.text}
                              </>
                            )
                          }
                          placement="top"
                          className="text-ellipsis d-inline-block wm-chart-card-title"
                        >
                          <span>
                            {channelImage ? (
                              <>
                                <img
                                  style={{
                                    width: "1.5rem",
                                    height: "1.5rem",
                                    marginRight: "0.5rem",
                                  }}
                                  src={
                                    channelImage
                                      ? SocialMedialogo?.[channelImage]
                                      : defaultImage
                                  }
                                />
                                {ProfileName}
                              </>
                            ) : genderName ? (
                              <>
                                <img
                                  style={{
                                    width: "1.5rem",
                                    height: "1.5rem",
                                    marginRight: "0.5rem",
                                  }}
                                  src={getGenderLogo(genderName)}
                                />
                                {genderName}
                              </>
                            ) : countryName ? (
                              <>
                                {getCountryLogo(countryName)}
                                {countryName}
                              </>
                            ) : (
                              <>
                                {data?.attribute === "Rating"
                                  ? `${
                                      data?.text?.length >= 40
                                        ? `${data?.text.substring(0, 40)}...`
                                        : data?.text
                                    } ⭐`
                                  : data?.text?.length >= 40
                                  ? `${data?.text.substring(0, 40)}...`
                                  : data?.text}
                              </>
                            )}
                          </span>
                        </Tooltip>
                        {data?.info_help_text && (
                          <Tooltip
                            title={data?.info_help_text}
                            placement="top"
                            className="text-ellipsis d-inline-block"
                          >
                            <i className="fa fa-question-circle cursor-pointer ml-1" />
                          </Tooltip>
                        )}
                        {data?.info_text && (
                          <Tooltip
                            title={data?.info_text}
                            placement="top"
                            className="text-ellipsis d-inline-block wm-chart-card-title"
                          >
                            <i className="fa fa-info-circle cursor-pointer ml-1" />
                          </Tooltip>
                        )}
                      </div>
                      {widgetShareOfData && data?.share ? (
                        <>
                          <div
                            className={`d-flex align-items-baseline  ${
                              !["000-000-556", "000-000-559"]?.includes(
                                authParams?.screen_id
                              )
                                ? "justify-content-center"
                                : ""
                            }`}
                          >
                            <Tooltip
                              placement="bottom"
                              title={
                                data?.value &&
                                (data?.isFlrFormatted ||
                                  graphConditionConfig?.[
                                    "ticket-time-label-attrs"
                                  ]?.includes(data?.y_series?.attribute))
                                  ? data?.value?.toString()?.includes(" | ")
                                    ? SecondstoHumanReadable(
                                        flrValue?.[0],
                                        true
                                      ) +
                                      " | " +
                                      flrValue?.[1]
                                    : SecondstoHumanReadable(data?.value, true)
                                  : data?.value
                                  ? TooltipFormatter(data?.value)
                                  : ""
                              }
                            >
                              <span
                                className={`${
                                  data?.text_color &&
                                  data?.text_color !== "#000000"
                                    ? "wm-chart-card-value-color"
                                    : "wm-chart-card-value"
                                } mr-1 no--wrap`}
                                style={
                                  data?.text_color &&
                                  data?.text_color !== "#000000"
                                    ? { color: data?.text_color }
                                    : {}
                                }
                              >
                                {data?.value === null
                                  ? "NA"
                                  : data?.value &&
                                    (data?.isFlrFormatted ||
                                      graphConditionConfig?.[
                                        "ticket-time-label-attrs"
                                      ]?.includes(data?.y_series?.attribute))
                                  ? data?.value?.toString()?.includes(" | ")
                                    ? SecondstoHumanReadable(
                                        flrValue?.[0],
                                        true
                                      ) +
                                      " | " +
                                      flrValue?.[1]
                                    : SecondstoHumanReadable(data?.value, true)
                                  : graphConditionConfig?.round_kpi_attrs?.includes(
                                      data?.attribute
                                    )
                                  ? isNaN(data?.value) && valueArray?.length > 1
                                    ? valueArray[0] + " " + valueArray[1]
                                    : kFormatter(data?.value, false, true)
                                  : isNaN(data?.value) && valueArray?.length > 1
                                  ? valueArray[0] + " " + valueArray[1]
                                  : kFormatter(data?.value, true)}
                              </span>
                            </Tooltip>
                            {data?.share ? (
                              <span className="d-flex align-items-center font-size12 font-weight600 text-blue cursor-default ml-1 no--wrap">
                                {/* <img
                                          src={ShareIcon}
                                          style={{ maxWidth: "1.5rem" }}
                                          className="mr-1"
                                        /> */}
                                <span
                                  className="pie__of--share mr-1"
                                  style={{
                                    border: "0.2rem solid " + "#185EDF",
                                    backgroundImage:
                                      "conic-gradient(" +
                                      "#185EDF " +
                                      data?.share * 3.6 +
                                      "deg,#ffff " +
                                      data?.share * 3.6 +
                                      "deg)",
                                  }}
                                ></span>
                                <span>{data?.share} %</span>
                              </span>
                            ) : (
                              <span className="text_regular font-size12 font-weight600 text-gray"></span>
                            )}
                          </div>
                          <div>
                            {widgetDurationComparison &&
                            data?.percent_change !== null ? (
                              <span
                                className={`text_regular justify-content-center ${
                                  data?.percent_change === 0
                                    ? "d-flex"
                                    : "d-flex"
                                } align-items-baseline ${
                                  String(data?.text).toLowerCase() ===
                                  String("Negative").toLowerCase()
                                    ? data?.percent_change > 0
                                      ? "negative"
                                      : data?.percent_change < 0
                                      ? "positive"
                                      : "text-gray"
                                    : data?.percent_change > 0
                                    ? "positive"
                                    : data?.percent_change < 0
                                    ? "negative"
                                    : "text-gray"
                                } font-size12`}
                              >
                                {data?.percent_change === null ? (
                                  ""
                                ) : data?.percent_change > 0 ? (
                                  <>
                                    <CaretUpFilled className="font-size18" />
                                    {" " +
                                      Number(
                                        data?.percent_change
                                      )?.toLocaleString() +
                                      "%"}
                                  </>
                                ) : data?.percent_change < 0 ? (
                                  <>
                                    <CaretDownFilled className="font-size18" />
                                    {" " +
                                      Number(
                                        data?.percent_change
                                      )?.toLocaleString() +
                                      "%"}
                                  </>
                                ) : (
                                  data?.percent_change !== null && "NA"
                                )}{" "}
                              </span>
                            ) : (
                              ""
                            )}
                          </div>
                        </>
                      ) : (
                        <div
                          className={`d-flex align-items-baseline ${
                            !["000-000-556", "000-000-559"]?.includes(
                              authParams?.screen_id
                            )
                              ? "justify-content-center"
                              : ""
                          }`}
                        >
                          <Tooltip
                            placement="bottom"
                            //className="d-flex"
                            title={
                              data?.value &&
                              (data?.isFlrFormatted ||
                                graphConditionConfig?.[
                                  "ticket-time-label-attrs"
                                ]?.includes(data?.y_series?.attribute))
                                ? data?.value?.toString()?.includes(" | ")
                                  ? SecondstoHumanReadable(
                                      flrValue?.[0],
                                      true
                                    ) +
                                    " | " +
                                    flrValue?.[1]
                                  : SecondstoHumanReadable(data?.value, true)
                                : data?.value
                                ? authParams?.screen_id === "000-000-559" &&
                                  !isDeepDiveDashboardView
                                  ? data?.value?.toLocaleString()
                                  : TooltipFormatter(data?.value)
                                : ""
                            }
                            style={{ whiteSpace: "nowrap" }}
                          >
                            <span
                              className={`${
                                data?.text_color &&
                                data?.text_color !== "#000000"
                                  ? "wm-chart-card-value-color"
                                  : "wm-chart-card-value"
                              } mr-1 no--wrap`}
                              style={
                                !isDeepDiveDashboardView &&
                                authParams?.screen_id === "000-000-559" &&
                                widget_metadata?.widget_id === "000-100-984"
                                  ? {
                                      color:
                                        "var(--locobuzz-secondary-text-color)",
                                    }
                                  : data?.text_color &&
                                    data?.text_color !== "#000000"
                                  ? { color: data?.text_color }
                                  : {}
                              }
                            >
                              {data?.value === null
                                ? "NA"
                                : data?.value &&
                                  (data?.isFlrFormatted ||
                                    graphConditionConfig?.[
                                      "ticket-time-label-attrs"
                                    ]?.includes(data?.y_series?.attribute))
                                ? data?.value?.toString()?.includes(" | ")
                                  ? SecondstoHumanReadable(
                                      flrValue?.[0],
                                      true
                                    ) +
                                    " | " +
                                    flrValue?.[1]
                                  : SecondstoHumanReadable(data?.value, true)
                                : graphConditionConfig?.round_kpi_attrs?.includes(
                                    data?.attribute
                                  )
                                ? isNaN(data?.value) && valueArray?.length > 1
                                  ? valueArray[0] + " " + valueArray[1]
                                  : kFormatter(data?.value, false, true)
                                : isNaN(data?.value) && valueArray?.length > 1
                                ? valueArray[0] + " " + valueArray[1]
                                : kFormatter(data?.value, true)}
                            </span>
                          </Tooltip>
                          {widgetDurationComparison &&
                          data?.percent_change !== null ? (
                            <span
                              className={`text_regular ${
                                data?.percent_change === 0 ? "d-flex" : "d-flex"
                              } align-items-baseline ${
                                String(data?.text).toLowerCase() ===
                                String("Negative").toLowerCase()
                                  ? data?.percent_change > 0
                                    ? "negative"
                                    : data?.percent_change < 0
                                    ? "positive"
                                    : "text-gray"
                                  : data?.percent_change > 0
                                  ? "positive"
                                  : data?.percent_change < 0
                                  ? "negative"
                                  : "text-gray"
                              } font-size12`}
                            >
                              {data?.percent_change === null ? (
                                ""
                              ) : data?.percent_change > 0 ? (
                                <>
                                  <CaretUpFilled className="font-size18" />
                                  {" " +
                                    Number(
                                      data?.percent_change
                                    )?.toLocaleString() +
                                    "%"}
                                </>
                              ) : data?.percent_change < 0 ? (
                                <>
                                  <CaretDownFilled className="font-size18" />
                                  {" " +
                                    Number(
                                      data?.percent_change
                                    )?.toLocaleString() +
                                    "%"}
                                </>
                              ) : (
                                data?.percent_change !== null && "NA"
                              )}{" "}
                            </span>
                          ) : (
                            ""
                          )}
                        </div>
                      )}
                    </div>
                  );
                }
            })
          )}
        </>
      )}
    </>
  );
};

export default KpiCards;
